import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Choices {
  static fromProto(proto) {
    let m = new Choices();
    m = Object.assign(m, proto);
    if (proto.rules) {
      m.rules = proto.rules.map(Rule$1.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    if (typeof this.defaultNextStep !== 'undefined') {
      toReturn['defaultNextStep'] = this.defaultNextStep;
    }
    return toReturn;
  }
}
let Rule$1 = class Rule {
  static fromProto(proto) {
    let m = new Rule();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.variablePath !== 'undefined') {
      toReturn['variablePath'] = this.variablePath;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.next !== 'undefined') {
      toReturn['next'] = this.next;
    }
    if (typeof this.comparison !== 'undefined') {
      toReturn['comparison'] = this.comparison;
    }
    return toReturn;
  }
};

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DataType = /*#__PURE__*/function (DataType) {
  DataType[DataType["DATA_TYPE_UNSPECIFIED"] = 0] = "DATA_TYPE_UNSPECIFIED";
  DataType[DataType["DATA_TYPE_UNKNOWN"] = 1] = "DATA_TYPE_UNKNOWN";
  DataType[DataType["DATA_TYPE_STRING"] = 2] = "DATA_TYPE_STRING";
  DataType[DataType["DATA_TYPE_BOOLEAN"] = 3] = "DATA_TYPE_BOOLEAN";
  DataType[DataType["DATA_TYPE_ORDER_ACTION_TYPE"] = 4] = "DATA_TYPE_ORDER_ACTION_TYPE";
  DataType[DataType["DATA_TYPE_ORDER_DECLINED_REASON_IDS"] = 5] = "DATA_TYPE_ORDER_DECLINED_REASON_IDS";
  DataType[DataType["DATA_TYPE_ACCOUNT_GROUP_ID"] = 6] = "DATA_TYPE_ACCOUNT_GROUP_ID";
  DataType[DataType["DATA_TYPE_ORDER_ID"] = 7] = "DATA_TYPE_ORDER_ID";
  DataType[DataType["DATA_TYPE_SMB_USER_ID"] = 8] = "DATA_TYPE_SMB_USER_ID";
  DataType[DataType["DATA_TYPE_FULFILLMENT_PROJECT_ID"] = 9] = "DATA_TYPE_FULFILLMENT_PROJECT_ID";
  DataType[DataType["DATA_TYPE_EMAIL_ID"] = 10] = "DATA_TYPE_EMAIL_ID";
  DataType[DataType["DATA_TYPE_EMAIL_EVENT"] = 11] = "DATA_TYPE_EMAIL_EVENT";
  DataType[DataType["DATA_TYPE_OPPORTUNITY_ID"] = 12] = "DATA_TYPE_OPPORTUNITY_ID";
  DataType[DataType["DATA_TYPE_JSON"] = 13] = "DATA_TYPE_JSON";
  DataType[DataType["DATA_TYPE_COMPANY_ID"] = 14] = "DATA_TYPE_COMPANY_ID";
  DataType[DataType["DATA_TYPE_CONTACT_ID"] = 15] = "DATA_TYPE_CONTACT_ID";
  DataType[DataType["DATA_TYPE_PRODUCT"] = 16] = "DATA_TYPE_PRODUCT";
  DataType[DataType["DATA_TYPE_TASK"] = 17] = "DATA_TYPE_TASK";
  DataType[DataType["DATA_TYPE_CRM_NOTE"] = 18] = "DATA_TYPE_CRM_NOTE";
  DataType[DataType["DATA_TYPE_CRM_EMAIL"] = 19] = "DATA_TYPE_CRM_EMAIL";
  DataType[DataType["DATA_TYPE_CRM_MEETING"] = 20] = "DATA_TYPE_CRM_MEETING";
  DataType[DataType["DATA_TYPE_CRM_CALL"] = 21] = "DATA_TYPE_CRM_CALL";
  DataType[DataType["DATA_TYPE_CRM_SMS"] = 22] = "DATA_TYPE_CRM_SMS";
  DataType[DataType["DATA_TYPE_CRM_LINKEDIN"] = 23] = "DATA_TYPE_CRM_LINKEDIN";
  DataType[DataType["DATA_TYPE_CRM_INBOX"] = 24] = "DATA_TYPE_CRM_INBOX";
  DataType[DataType["DATA_TYPE_INTEGRATION_CONNECTION"] = 25] = "DATA_TYPE_INTEGRATION_CONNECTION";
  DataType[DataType["DATA_TYPE_NUMBER"] = 26] = "DATA_TYPE_NUMBER";
  DataType[DataType["DATA_TYPE_CURRENCY"] = 27] = "DATA_TYPE_CURRENCY";
  DataType[DataType["DATA_TYPE_DATETIME"] = 28] = "DATA_TYPE_DATETIME";
  DataType[DataType["DATA_TYPE_CRM_OPPORTUNITY_ID"] = 29] = "DATA_TYPE_CRM_OPPORTUNITY_ID";
  return DataType;
}(DataType || {});
var ValidationType = /*#__PURE__*/function (ValidationType) {
  ValidationType[ValidationType["VALIDATION_TYPE_UNSPECIFIED"] = 0] = "VALIDATION_TYPE_UNSPECIFIED";
  ValidationType[ValidationType["VALIDATION_TYPE_STREAM"] = 1] = "VALIDATION_TYPE_STREAM";
  ValidationType[ValidationType["VALIDATION_TYPE_USER_PROVIDED"] = 2] = "VALIDATION_TYPE_USER_PROVIDED";
  ValidationType[ValidationType["VALIDATION_TYPE_SYSTEM"] = 3] = "VALIDATION_TYPE_SYSTEM";
  return ValidationType;
}(ValidationType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Context = /*#__PURE__*/function (Context) {
  Context[Context["AUTOMATION_CONTEXT_UNSET"] = 0] = "AUTOMATION_CONTEXT_UNSET";
  Context[Context["AUTOMATION_CONTEXT_PARTNER"] = 1] = "AUTOMATION_CONTEXT_PARTNER";
  Context[Context["AUTOMATION_CONTEXT_SMB"] = 2] = "AUTOMATION_CONTEXT_SMB";
  return Context;
}(Context || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EntityType = /*#__PURE__*/function (EntityType) {
  EntityType[EntityType["ENTITY_TYPE_NOT_SPECIFIED"] = 0] = "ENTITY_TYPE_NOT_SPECIFIED";
  EntityType[EntityType["ENTITY_TYPE_ACCOUNT_GROUP"] = 1] = "ENTITY_TYPE_ACCOUNT_GROUP";
  EntityType[EntityType["ENTITY_TYPE_ORDER"] = 2] = "ENTITY_TYPE_ORDER";
  EntityType[EntityType["ENTITY_TYPE_USER"] = 3] = "ENTITY_TYPE_USER";
  EntityType[EntityType["ENTITY_TYPE_NO_ENTITY"] = 4] = "ENTITY_TYPE_NO_ENTITY";
  EntityType[EntityType["ENTITY_TYPE_CONTACT"] = 5] = "ENTITY_TYPE_CONTACT";
  EntityType[EntityType["ENTITY_TYPE_COMPANY"] = 6] = "ENTITY_TYPE_COMPANY";
  return EntityType;
}(EntityType || {});
var ErrorHandlingType = /*#__PURE__*/function (ErrorHandlingType) {
  ErrorHandlingType[ErrorHandlingType["ERROR_HANDLING_TYPE_UNDEFINED"] = 0] = "ERROR_HANDLING_TYPE_UNDEFINED";
  ErrorHandlingType[ErrorHandlingType["ERROR_HANDLING_TYPE_STOP_ON_ERROR"] = 1] = "ERROR_HANDLING_TYPE_STOP_ON_ERROR";
  ErrorHandlingType[ErrorHandlingType["ERROR_HANDLING_TYPE_CONTINUE_ON_ERROR"] = 2] = "ERROR_HANDLING_TYPE_CONTINUE_ON_ERROR";
  return ErrorHandlingType;
}(ErrorHandlingType || {});
var RunType = /*#__PURE__*/function (RunType) {
  RunType[RunType["RUN_TYPE_NOT_SPECIFIED"] = 0] = "RUN_TYPE_NOT_SPECIFIED";
  RunType[RunType["RUN_TYPE_ONLY_ONCE"] = 1] = "RUN_TYPE_ONLY_ONCE";
  RunType[RunType["RUN_TYPE_MULTIPLE"] = 2] = "RUN_TYPE_MULTIPLE";
  RunType[RunType["RUN_TYPE_ONE_AT_A_TIME"] = 3] = "RUN_TYPE_ONE_AT_A_TIME";
  return RunType;
}(RunType || {});
var RunningState = /*#__PURE__*/function (RunningState) {
  RunningState[RunningState["RUNNING_STATE_NOT_SPECIFIED"] = 0] = "RUNNING_STATE_NOT_SPECIFIED";
  RunningState[RunningState["RUNNING_STATE_RUNNING"] = 1] = "RUNNING_STATE_RUNNING";
  RunningState[RunningState["RUNNING_STATE_STOPPED"] = 2] = "RUNNING_STATE_STOPPED";
  RunningState[RunningState["RUNNING_STATE_DRAINING"] = 3] = "RUNNING_STATE_DRAINING";
  return RunningState;
}(RunningState || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Stage = /*#__PURE__*/function (Stage) {
  Stage[Stage["STAGE_NOT_SPECIFIED"] = 0] = "STAGE_NOT_SPECIFIED";
  Stage[Stage["STAGE_WORKFLOW_STEP"] = 1] = "STAGE_WORKFLOW_STEP";
  Stage[Stage["STAGE_WORKFLOW_COMPLETED"] = 2] = "STAGE_WORKFLOW_COMPLETED";
  Stage[Stage["STAGE_WORKFLOW_CANCELED"] = 3] = "STAGE_WORKFLOW_CANCELED";
  Stage[Stage["STAGE_WORKFLOW_COMPLETED_FROM_ERROR"] = 4] = "STAGE_WORKFLOW_COMPLETED_FROM_ERROR";
  Stage[Stage["STAGE_WORKFLOW_DID_NOT_RUN"] = 5] = "STAGE_WORKFLOW_DID_NOT_RUN";
  Stage[Stage["STAGE_WORKFLOW_CONTINUED_FROM_ERROR"] = 6] = "STAGE_WORKFLOW_CONTINUED_FROM_ERROR";
  Stage[Stage["STAGE_WORKFLOW_CONTINUED"] = 7] = "STAGE_WORKFLOW_CONTINUED";
  return Stage;
}(Stage || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FlattenedConfigDataType = /*#__PURE__*/function (FlattenedConfigDataType) {
  FlattenedConfigDataType[FlattenedConfigDataType["FLATTENED_CONFIG_DATA_TYPE_UNSET"] = 0] = "FLATTENED_CONFIG_DATA_TYPE_UNSET";
  FlattenedConfigDataType[FlattenedConfigDataType["FLATTENED_CONFIG_DATA_TYPE_STRUCT"] = 1] = "FLATTENED_CONFIG_DATA_TYPE_STRUCT";
  FlattenedConfigDataType[FlattenedConfigDataType["FLATTENED_CONFIG_DATA_TYPE_STRING"] = 2] = "FLATTENED_CONFIG_DATA_TYPE_STRING";
  FlattenedConfigDataType[FlattenedConfigDataType["FLATTENED_CONFIG_DATA_TYPE_INT"] = 3] = "FLATTENED_CONFIG_DATA_TYPE_INT";
  FlattenedConfigDataType[FlattenedConfigDataType["FLATTENED_CONFIG_DATA_TYPE_FLOAT"] = 4] = "FLATTENED_CONFIG_DATA_TYPE_FLOAT";
  FlattenedConfigDataType[FlattenedConfigDataType["FLATTENED_CONFIG_DATA_TYPE_BOOL"] = 5] = "FLATTENED_CONFIG_DATA_TYPE_BOOL";
  FlattenedConfigDataType[FlattenedConfigDataType["FLATTENED_CONFIG_DATA_TYPE_TIME"] = 6] = "FLATTENED_CONFIG_DATA_TYPE_TIME";
  return FlattenedConfigDataType;
}(FlattenedConfigDataType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PublishedState = /*#__PURE__*/function (PublishedState) {
  PublishedState[PublishedState["PUBLISHED_STATE_UNSPECIFIED"] = 0] = "PUBLISHED_STATE_UNSPECIFIED";
  PublishedState[PublishedState["PUBLISHED_STATE_PUBLISHED"] = 1] = "PUBLISHED_STATE_PUBLISHED";
  PublishedState[PublishedState["PUBLISHED_STATE_DRAFT"] = 2] = "PUBLISHED_STATE_DRAFT";
  return PublishedState;
}(PublishedState || {});
var TaskType = /*#__PURE__*/function (TaskType) {
  TaskType[TaskType["TASK_TYPE_UNSPECIFIED"] = 0] = "TASK_TYPE_UNSPECIFIED";
  TaskType[TaskType["TASK_TYPE_ACTION"] = 1] = "TASK_TYPE_ACTION";
  TaskType[TaskType["TASK_TYPE_TRIGGER"] = 2] = "TASK_TYPE_TRIGGER";
  TaskType[TaskType["TASK_TYPE_BUILDING_BLOCKS"] = 3] = "TASK_TYPE_BUILDING_BLOCKS";
  TaskType[TaskType["TASK_TYPE_FILTER"] = 4] = "TASK_TYPE_FILTER";
  return TaskType;
}(TaskType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var RateLimitUnit = /*#__PURE__*/function (RateLimitUnit) {
  RateLimitUnit[RateLimitUnit["RATE_LIMIT_UNIT_UNSPECIFIED"] = 0] = "RATE_LIMIT_UNIT_UNSPECIFIED";
  RateLimitUnit[RateLimitUnit["RATE_LIMIT_UNIT_HOUR"] = 1] = "RATE_LIMIT_UNIT_HOUR";
  RateLimitUnit[RateLimitUnit["RATE_LIMIT_UNIT_DAY"] = 2] = "RATE_LIMIT_UNIT_DAY";
  return RateLimitUnit;
}(RateLimitUnit || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AutomationPublishedState = /*#__PURE__*/function (AutomationPublishedState) {
  AutomationPublishedState[AutomationPublishedState["AUTOMATION_PUBLISHED_STATE_NOT_SPECIFIED"] = 0] = "AUTOMATION_PUBLISHED_STATE_NOT_SPECIFIED";
  AutomationPublishedState[AutomationPublishedState["AUTOMATION_PUBLISHED_STATE_PUBLISHED"] = 1] = "AUTOMATION_PUBLISHED_STATE_PUBLISHED";
  AutomationPublishedState[AutomationPublishedState["AUTOMATION_PUBLISHED_STATE_DRAFT"] = 2] = "AUTOMATION_PUBLISHED_STATE_DRAFT";
  return AutomationPublishedState;
}(AutomationPublishedState || {});
var AutomationStatus = /*#__PURE__*/function (AutomationStatus) {
  AutomationStatus[AutomationStatus["AUTOMATION_STATUS_NOT_SPECIFIED"] = 0] = "AUTOMATION_STATUS_NOT_SPECIFIED";
  AutomationStatus[AutomationStatus["AUTOMATION_STATUS_ON"] = 1] = "AUTOMATION_STATUS_ON";
  AutomationStatus[AutomationStatus["AUTOMATION_STATUS_OFF"] = 2] = "AUTOMATION_STATUS_OFF";
  return AutomationStatus;
}(AutomationStatus || {});
var AutomationType = /*#__PURE__*/function (AutomationType) {
  AutomationType[AutomationType["AUTOMATION_TYPE_NOT_SPECIFIED"] = 0] = "AUTOMATION_TYPE_NOT_SPECIFIED";
  AutomationType[AutomationType["AUTOMATION_TYPE_STANDARD"] = 1] = "AUTOMATION_TYPE_STANDARD";
  AutomationType[AutomationType["AUTOMATION_TYPE_DEFAULT"] = 2] = "AUTOMATION_TYPE_DEFAULT";
  AutomationType[AutomationType["AUTOMATION_TYPE_TEMPLATE"] = 3] = "AUTOMATION_TYPE_TEMPLATE";
  AutomationType[AutomationType["AUTOMATION_TYPE_SNIPPET"] = 4] = "AUTOMATION_TYPE_SNIPPET";
  return AutomationType;
}(AutomationType || {});
var DefaultAutomationStatus = /*#__PURE__*/function (DefaultAutomationStatus) {
  DefaultAutomationStatus[DefaultAutomationStatus["LIST_DEFAULT_AUTOMATIONS_FOR_PARTNER_REQUEST_DEFAULT_AUTOMATION_STATUS_ON"] = 0] = "LIST_DEFAULT_AUTOMATIONS_FOR_PARTNER_REQUEST_DEFAULT_AUTOMATION_STATUS_ON";
  DefaultAutomationStatus[DefaultAutomationStatus["LIST_DEFAULT_AUTOMATIONS_FOR_PARTNER_REQUEST_DEFAULT_AUTOMATION_STATUS_OFF"] = 1] = "LIST_DEFAULT_AUTOMATIONS_FOR_PARTNER_REQUEST_DEFAULT_AUTOMATION_STATUS_OFF";
  return DefaultAutomationStatus;
}(DefaultAutomationStatus || {});
// *********************************

function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class InputParameter {
  static fromProto(proto) {
    let m = new InputParameter();
    m = Object.assign(m, proto);
    if (proto.settings) {
      m.settings = Parameter.fromProto(proto.settings);
    }
    if (proto.validationType) {
      m.validationType = enumStringToValue$a(ValidationType, proto.validationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.validationType !== 'undefined') {
      toReturn['validationType'] = this.validationType;
    }
    return toReturn;
  }
}
class OutputParameter {
  static fromProto(proto) {
    let m = new OutputParameter();
    m = Object.assign(m, proto);
    if (proto.settings) {
      m.settings = Parameter.fromProto(proto.settings);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    if (typeof this.optional !== 'undefined') {
      toReturn['optional'] = this.optional;
    }
    if (typeof this.isEntity !== 'undefined') {
      toReturn['isEntity'] = this.isEntity;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    return toReturn;
  }
}
class Parameter {
  static fromProto(proto) {
    let m = new Parameter();
    m = Object.assign(m, proto);
    if (proto.dataType) {
      m.dataType = enumStringToValue$a(DataType, proto.dataType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.dataType !== 'undefined') {
      toReturn['dataType'] = this.dataType;
    }
    if (typeof this.repeated !== 'undefined') {
      toReturn['repeated'] = this.repeated;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Automation {
  static fromProto(proto) {
    let m = new Automation();
    m = Object.assign(m, proto);
    if (proto.runningState) {
      m.runningState = enumStringToValue$9(RunningState, proto.runningState);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.workflow) {
      m.workflow = proto.workflow.map(WorkflowStep.fromProto);
    }
    if (proto.triggerStep) {
      m.triggerStep = WorkflowStep.fromProto(proto.triggerStep);
    }
    if (proto.settings) {
      m.settings = AutomationSettings.fromProto(proto.settings);
    }
    if (proto.triggerFilters) {
      m.triggerFilters = proto.triggerFilters.map(WorkflowStep.fromProto);
    }
    if (proto.runningVersion) {
      m.runningVersion = new Date(proto.runningVersion);
    }
    if (proto.templatePublishedTime) {
      m.templatePublishedTime = new Date(proto.templatePublishedTime);
    }
    if (proto.defaultAutomationPublishedTime) {
      m.defaultAutomationPublishedTime = new Date(proto.defaultAutomationPublishedTime);
    }
    if (proto.entityType) {
      m.entityType = enumStringToValue$9(EntityType, proto.entityType);
    }
    if (proto.token) {
      m.token = Token.fromProto(proto.token);
    }
    if (proto.context) {
      m.context = enumStringToValue$9(Context, proto.context);
    }
    if (proto.groups) {
      m.groups = proto.groups.map(Group.fromProto);
    }
    if (proto.snippetAutomationPublishedTime) {
      m.snippetAutomationPublishedTime = new Date(proto.snippetAutomationPublishedTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.triggerDefinitionId !== 'undefined') {
      toReturn['triggerDefinitionId'] = this.triggerDefinitionId;
    }
    if (typeof this.triggerSubDefinitionId !== 'undefined') {
      toReturn['triggerSubDefinitionId'] = this.triggerSubDefinitionId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.runningState !== 'undefined') {
      toReturn['runningState'] = this.runningState;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.workflow !== 'undefined' && this.workflow !== null) {
      toReturn['workflow'] = 'toApiJson' in this.workflow ? this.workflow.toApiJson() : this.workflow;
    }
    if (typeof this.triggerStep !== 'undefined' && this.triggerStep !== null) {
      toReturn['triggerStep'] = 'toApiJson' in this.triggerStep ? this.triggerStep.toApiJson() : this.triggerStep;
    }
    if (typeof this.lastEditedBy !== 'undefined') {
      toReturn['lastEditedBy'] = this.lastEditedBy;
    }
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    if (typeof this.triggerFilters !== 'undefined' && this.triggerFilters !== null) {
      toReturn['triggerFilters'] = 'toApiJson' in this.triggerFilters ? this.triggerFilters.toApiJson() : this.triggerFilters;
    }
    if (typeof this.runningVersion !== 'undefined' && this.runningVersion !== null) {
      toReturn['runningVersion'] = 'toApiJson' in this.runningVersion ? this.runningVersion.toApiJson() : this.runningVersion;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.isTemplate !== 'undefined') {
      toReturn['isTemplate'] = this.isTemplate;
    }
    if (typeof this.templatePublishedTime !== 'undefined' && this.templatePublishedTime !== null) {
      toReturn['templatePublishedTime'] = 'toApiJson' in this.templatePublishedTime ? this.templatePublishedTime.toApiJson() : this.templatePublishedTime;
    }
    if (typeof this.isDefaultAutomation !== 'undefined') {
      toReturn['isDefaultAutomation'] = this.isDefaultAutomation;
    }
    if (typeof this.defaultAutomationPublishedTime !== 'undefined' && this.defaultAutomationPublishedTime !== null) {
      toReturn['defaultAutomationPublishedTime'] = 'toApiJson' in this.defaultAutomationPublishedTime ? this.defaultAutomationPublishedTime.toApiJson() : this.defaultAutomationPublishedTime;
    }
    if (typeof this.originTemplateId !== 'undefined') {
      toReturn['originTemplateId'] = this.originTemplateId;
    }
    if (typeof this.originDefaultAutomationId !== 'undefined') {
      toReturn['originDefaultAutomationId'] = this.originDefaultAutomationId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.hidden !== 'undefined') {
      toReturn['hidden'] = this.hidden;
    }
    if (typeof this.entityType !== 'undefined') {
      toReturn['entityType'] = this.entityType;
    }
    if (typeof this.token !== 'undefined' && this.token !== null) {
      toReturn['token'] = 'toApiJson' in this.token ? this.token.toApiJson() : this.token;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    if (typeof this.isSnippetAutomation !== 'undefined') {
      toReturn['isSnippetAutomation'] = this.isSnippetAutomation;
    }
    if (typeof this.snippetAutomationPublishedTime !== 'undefined' && this.snippetAutomationPublishedTime !== null) {
      toReturn['snippetAutomationPublishedTime'] = 'toApiJson' in this.snippetAutomationPublishedTime ? this.snippetAutomationPublishedTime.toApiJson() : this.snippetAutomationPublishedTime;
    }
    return toReturn;
  }
}
class AutomationSettings {
  static fromProto(proto) {
    let m = new AutomationSettings();
    m = Object.assign(m, proto);
    if (proto.runType) {
      m.runType = enumStringToValue$9(RunType, proto.runType);
    }
    if (proto.errorHandlingType) {
      m.errorHandlingType = enumStringToValue$9(ErrorHandlingType, proto.errorHandlingType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.runType !== 'undefined') {
      toReturn['runType'] = this.runType;
    }
    if (typeof this.errorHandlingType !== 'undefined') {
      toReturn['errorHandlingType'] = this.errorHandlingType;
    }
    if (typeof this.timeZone !== 'undefined') {
      toReturn['timeZone'] = this.timeZone;
    }
    return toReturn;
  }
}
class Group {
  static fromProto(proto) {
    let m = new Group();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class SleepWaitConditions {
  static fromProto(proto) {
    let m = new SleepWaitConditions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.weekdaySelection !== 'undefined') {
      toReturn['weekdaySelection'] = this.weekdaySelection;
    }
    if (typeof this.timeRangeStartHour !== 'undefined') {
      toReturn['timeRangeStartHour'] = this.timeRangeStartHour;
    }
    if (typeof this.timeRangeStartMinute !== 'undefined') {
      toReturn['timeRangeStartMinute'] = this.timeRangeStartMinute;
    }
    if (typeof this.timeRangeEndHour !== 'undefined') {
      toReturn['timeRangeEndHour'] = this.timeRangeEndHour;
    }
    if (typeof this.timeRangeEndMinute !== 'undefined') {
      toReturn['timeRangeEndMinute'] = this.timeRangeEndMinute;
    }
    if (typeof this.dayOfMonthSelection !== 'undefined') {
      toReturn['dayOfMonthSelection'] = this.dayOfMonthSelection;
    }
    return toReturn;
  }
}
class Token {
  static fromProto(proto) {
    let m = new Token();
    m = Object.assign(m, proto);
    if (proto.refreshTokenExpiry) {
      m.refreshTokenExpiry = new Date(proto.refreshTokenExpiry);
    }
    if (proto.brokenTime) {
      m.brokenTime = new Date(proto.brokenTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.scopes !== 'undefined') {
      toReturn['scopes'] = this.scopes;
    }
    if (typeof this.refreshTokenExpiry !== 'undefined' && this.refreshTokenExpiry !== null) {
      toReturn['refreshTokenExpiry'] = 'toApiJson' in this.refreshTokenExpiry ? this.refreshTokenExpiry.toApiJson() : this.refreshTokenExpiry;
    }
    if (typeof this.brokenTime !== 'undefined' && this.brokenTime !== null) {
      toReturn['brokenTime'] = 'toApiJson' in this.brokenTime ? this.brokenTime.toApiJson() : this.brokenTime;
    }
    return toReturn;
  }
}
class WaitForTriggerFilter {
  static fromProto(proto) {
    let m = new WaitForTriggerFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class WorkflowStep {
  static fromProto(proto) {
    let m = new WorkflowStep();
    m = Object.assign(m, proto);
    if (proto.choices) {
      m.choices = Choices.fromProto(proto.choices);
    }
    if (proto.sleep) {
      m.sleep = parseInt(proto.sleep, 10);
    }
    if (proto.customOutputParameters) {
      m.customOutputParameters = proto.customOutputParameters.map(OutputParameter.fromProto);
    }
    if (proto.waitForTriggerFilter) {
      m.waitForTriggerFilter = WaitForTriggerFilter.fromProto(proto.waitForTriggerFilter);
    }
    if (proto.sleepWaitConditions) {
      m.sleepWaitConditions = SleepWaitConditions.fromProto(proto.sleepWaitConditions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.taskDefinitionId !== 'undefined') {
      toReturn['taskDefinitionId'] = this.taskDefinitionId;
    }
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    if (typeof this.choices !== 'undefined' && this.choices !== null) {
      toReturn['choices'] = 'toApiJson' in this.choices ? this.choices.toApiJson() : this.choices;
    }
    if (typeof this.sleep !== 'undefined') {
      toReturn['sleep'] = this.sleep;
    }
    if (typeof this.waitForTriggerDefinitionId !== 'undefined') {
      toReturn['waitForTriggerDefinitionId'] = this.waitForTriggerDefinitionId;
    }
    if (typeof this.waitForTriggerTaskDefinitionId !== 'undefined') {
      toReturn['waitForTriggerTaskDefinitionId'] = this.waitForTriggerTaskDefinitionId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.customOutputParameters !== 'undefined' && this.customOutputParameters !== null) {
      toReturn['customOutputParameters'] = 'toApiJson' in this.customOutputParameters ? this.customOutputParameters.toApiJson() : this.customOutputParameters;
    }
    if (typeof this.waitForTriggerFilter !== 'undefined' && this.waitForTriggerFilter !== null) {
      toReturn['waitForTriggerFilter'] = 'toApiJson' in this.waitForTriggerFilter ? this.waitForTriggerFilter.toApiJson() : this.waitForTriggerFilter;
    }
    if (typeof this.clearedDataFlag !== 'undefined') {
      toReturn['clearedDataFlag'] = this.clearedDataFlag;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.sleepWaitConditions !== 'undefined' && this.sleepWaitConditions !== null) {
      toReturn['sleepWaitConditions'] = 'toApiJson' in this.sleepWaitConditions ? this.sleepWaitConditions.toApiJson() : this.sleepWaitConditions;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    return toReturn;
  }
}
class WorkflowStepOutputParameterContainer {
  static fromProto(proto) {
    let m = new WorkflowStepOutputParameterContainer();
    m = Object.assign(m, proto);
    if (proto.workflowStep) {
      m.workflowStep = WorkflowStep.fromProto(proto.workflowStep);
    }
    if (proto.outputParameters) {
      m.outputParameters = proto.outputParameters.map(OutputParameter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.workflowStep !== 'undefined' && this.workflowStep !== null) {
      toReturn['workflowStep'] = 'toApiJson' in this.workflowStep ? this.workflowStep.toApiJson() : this.workflowStep;
    }
    if (typeof this.outputParameters !== 'undefined' && this.outputParameters !== null) {
      toReturn['outputParameters'] = 'toApiJson' in this.outputParameters ? this.outputParameters.toApiJson() : this.outputParameters;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AutomationConfiguration {
  static fromProto(proto) {
    let m = new AutomationConfiguration();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.disabledMarkets !== 'undefined') {
      toReturn['disabledMarkets'] = this.disabledMarkets;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class AutomationConfigurationV2 {
  static fromProto(proto) {
    let m = new AutomationConfigurationV2();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue$8(Context, proto.context);
    }
    if (proto.disabled) {
      m.disabled = new Date(proto.disabled);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.disabled !== 'undefined' && this.disabled !== null) {
      toReturn['disabled'] = 'toApiJson' in this.disabled ? this.disabled.toApiJson() : this.disabled;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class AutomationConfigurationV2Identifier {
  static fromProto(proto) {
    let m = new AutomationConfigurationV2Identifier();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue$8(Context, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AutomationSubscription {
  static fromProto(proto) {
    let m = new AutomationSubscription();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Activity {
  static fromProto(proto) {
    let m = new Activity();
    m = Object.assign(m, proto);
    if (proto.error) {
      m.error = Error.fromProto(proto.error);
    }
    if (proto.startedProcessing) {
      m.startedProcessing = new Date(proto.startedProcessing);
    }
    if (proto.completedProcessing) {
      m.completedProcessing = new Date(proto.completedProcessing);
    }
    if (proto.workflowStep) {
      m.workflowStep = WorkflowStep.fromProto(proto.workflowStep);
    }
    if (proto.nextWorkflowStep) {
      m.nextWorkflowStep = WorkflowStep.fromProto(proto.nextWorkflowStep);
    }
    if (proto.stage) {
      m.stage = enumStringToValue$6(Stage, proto.stage);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.runId !== 'undefined') {
      toReturn['runId'] = this.runId;
    }
    if (typeof this.error !== 'undefined' && this.error !== null) {
      toReturn['error'] = 'toApiJson' in this.error ? this.error.toApiJson() : this.error;
    }
    if (typeof this.startedProcessing !== 'undefined' && this.startedProcessing !== null) {
      toReturn['startedProcessing'] = 'toApiJson' in this.startedProcessing ? this.startedProcessing.toApiJson() : this.startedProcessing;
    }
    if (typeof this.completedProcessing !== 'undefined' && this.completedProcessing !== null) {
      toReturn['completedProcessing'] = 'toApiJson' in this.completedProcessing ? this.completedProcessing.toApiJson() : this.completedProcessing;
    }
    if (typeof this.workflowStep !== 'undefined' && this.workflowStep !== null) {
      toReturn['workflowStep'] = 'toApiJson' in this.workflowStep ? this.workflowStep.toApiJson() : this.workflowStep;
    }
    if (typeof this.inputData !== 'undefined') {
      toReturn['inputData'] = this.inputData;
    }
    if (typeof this.outputData !== 'undefined') {
      toReturn['outputData'] = this.outputData;
    }
    if (typeof this.activityData !== 'undefined') {
      toReturn['activityData'] = this.activityData;
    }
    if (typeof this.nextWorkflowStep !== 'undefined' && this.nextWorkflowStep !== null) {
      toReturn['nextWorkflowStep'] = 'toApiJson' in this.nextWorkflowStep ? this.nextWorkflowStep.toApiJson() : this.nextWorkflowStep;
    }
    if (typeof this.stage !== 'undefined') {
      toReturn['stage'] = this.stage;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.waitForTriggerDefinitionId !== 'undefined') {
      toReturn['waitForTriggerDefinitionId'] = this.waitForTriggerDefinitionId;
    }
    if (typeof this.triggerData !== 'undefined') {
      toReturn['triggerData'] = this.triggerData;
    }
    if (typeof this.endRunRequested !== 'undefined') {
      toReturn['endRunRequested'] = this.endRunRequested;
    }
    if (typeof this.mainRunId !== 'undefined') {
      toReturn['mainRunId'] = this.mainRunId;
    }
    if (typeof this.stepExecutionUuid !== 'undefined') {
      toReturn['stepExecutionUuid'] = this.stepExecutionUuid;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class Error {
  static fromProto(proto) {
    let m = new Error();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.code !== 'undefined') {
      toReturn['code'] = this.code;
    }
    if (typeof this.humanReadableMessage !== 'undefined') {
      toReturn['humanReadableMessage'] = this.humanReadableMessage;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class EventTriggerDefinition {
  static fromProto(proto) {
    let m = new EventTriggerDefinition();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.flattenedConfig) {
      m.flattenedConfig = FlattenedConfig.fromProto(proto.flattenedConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.parametersPaths !== 'undefined') {
      toReturn['parametersPaths'] = this.parametersPaths;
    }
    if (typeof this.triggerContextIdFormat !== 'undefined') {
      toReturn['triggerContextIdFormat'] = this.triggerContextIdFormat;
    }
    if (typeof this.lastEditedBy !== 'undefined') {
      toReturn['lastEditedBy'] = this.lastEditedBy;
    }
    if (typeof this.parameterFilterKeys !== 'undefined') {
      toReturn['parameterFilterKeys'] = this.parameterFilterKeys;
    }
    if (typeof this.flattenedConfig !== 'undefined' && this.flattenedConfig !== null) {
      toReturn['flattenedConfig'] = 'toApiJson' in this.flattenedConfig ? this.flattenedConfig.toApiJson() : this.flattenedConfig;
    }
    return toReturn;
  }
}
class FlattenedConfig {
  static fromProto(proto) {
    let m = new FlattenedConfig();
    m = Object.assign(m, proto);
    if (proto.dataType) {
      m.dataType = enumStringToValue$5(FlattenedConfigDataType, proto.dataType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourcePath !== 'undefined') {
      toReturn['sourcePath'] = this.sourcePath;
    }
    if (typeof this.dataType !== 'undefined') {
      toReturn['dataType'] = this.dataType;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppKey {
  static fromProto(proto) {
    let m = new AppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class CallOptions {
  static fromProto(proto) {
    let m = new CallOptions();
    m = Object.assign(m, proto);
    if (proto.retryPolicyOptions) {
      m.retryPolicyOptions = proto.retryPolicyOptions.map(RetryPolicy.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.retryPolicyOptions !== 'undefined' && this.retryPolicyOptions !== null) {
      toReturn['retryPolicyOptions'] = 'toApiJson' in this.retryPolicyOptions ? this.retryPolicyOptions.toApiJson() : this.retryPolicyOptions;
    }
    return toReturn;
  }
}
class Resource {
  static fromProto(proto) {
    let m = new Resource();
    m = Object.assign(m, proto);
    if (proto.callOptions) {
      m.callOptions = CallOptions.fromProto(proto.callOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.method !== 'undefined') {
      toReturn['method'] = this.method;
    }
    if (typeof this.isGetter !== 'undefined') {
      toReturn['isGetter'] = this.isGetter;
    }
    if (typeof this.callOptions !== 'undefined' && this.callOptions !== null) {
      toReturn['callOptions'] = 'toApiJson' in this.callOptions ? this.callOptions.toApiJson() : this.callOptions;
    }
    return toReturn;
  }
}
class RetryPolicy {
  static fromProto(proto) {
    let m = new RetryPolicy();
    m = Object.assign(m, proto);
    if (proto.maximumAttempts) {
      m.maximumAttempts = parseInt(proto.maximumAttempts, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusCode !== 'undefined') {
      toReturn['statusCode'] = this.statusCode;
    }
    if (typeof this.maximumAttempts !== 'undefined') {
      toReturn['maximumAttempts'] = this.maximumAttempts;
    }
    return toReturn;
  }
}
class TaskDefinition {
  static fromProto(proto) {
    let m = new TaskDefinition();
    m = Object.assign(m, proto);
    if (proto.resource) {
      m.resource = Resource.fromProto(proto.resource);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.inputParameters) {
      m.inputParameters = proto.inputParameters.map(InputParameter.fromProto);
    }
    if (proto.outputParameters) {
      m.outputParameters = proto.outputParameters.map(OutputParameter.fromProto);
    }
    if (proto.taskType) {
      m.taskType = enumStringToValue$4(TaskType, proto.taskType);
    }
    if (proto.publishedState) {
      m.publishedState = enumStringToValue$4(PublishedState, proto.publishedState);
    }
    if (proto.preProcessors) {
      m.preProcessors = proto.preProcessors.map(WorkflowStep.fromProto);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$4(Context, v));
    }
    if (proto.choices) {
      m.choices = Choices.fromProto(proto.choices);
    }
    if (proto.requiredApps) {
      m.requiredApps = proto.requiredApps.map(AppKey.fromProto);
    }
    if (proto.staticValidationRules) {
      m.staticValidationRules = Choices.fromProto(proto.staticValidationRules);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.resource !== 'undefined' && this.resource !== null) {
      toReturn['resource'] = 'toApiJson' in this.resource ? this.resource.toApiJson() : this.resource;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.inputParameters !== 'undefined' && this.inputParameters !== null) {
      toReturn['inputParameters'] = 'toApiJson' in this.inputParameters ? this.inputParameters.toApiJson() : this.inputParameters;
    }
    if (typeof this.outputParameters !== 'undefined' && this.outputParameters !== null) {
      toReturn['outputParameters'] = 'toApiJson' in this.outputParameters ? this.outputParameters.toApiJson() : this.outputParameters;
    }
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.internal !== 'undefined') {
      toReturn['internal'] = this.internal;
    }
    if (typeof this.publishedState !== 'undefined') {
      toReturn['publishedState'] = this.publishedState;
    }
    if (typeof this.requiredScopes !== 'undefined') {
      toReturn['requiredScopes'] = this.requiredScopes;
    }
    if (typeof this.availableInDefaultAutomations !== 'undefined') {
      toReturn['availableInDefaultAutomations'] = this.availableInDefaultAutomations;
    }
    if (typeof this.requiredSubscriptionFeatures !== 'undefined') {
      toReturn['requiredSubscriptionFeatures'] = this.requiredSubscriptionFeatures;
    }
    if (typeof this.lastEditedBy !== 'undefined') {
      toReturn['lastEditedBy'] = this.lastEditedBy;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.preProcessors !== 'undefined' && this.preProcessors !== null) {
      toReturn['preProcessors'] = 'toApiJson' in this.preProcessors ? this.preProcessors.toApiJson() : this.preProcessors;
    }
    if (typeof this.marketReliant !== 'undefined') {
      toReturn['marketReliant'] = this.marketReliant;
    }
    if (typeof this.eventSubTypeId !== 'undefined') {
      toReturn['eventSubTypeId'] = this.eventSubTypeId;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    if (typeof this.choices !== 'undefined' && this.choices !== null) {
      toReturn['choices'] = 'toApiJson' in this.choices ? this.choices.toApiJson() : this.choices;
    }
    if (typeof this.requiredApps !== 'undefined' && this.requiredApps !== null) {
      toReturn['requiredApps'] = 'toApiJson' in this.requiredApps ? this.requiredApps.toApiJson() : this.requiredApps;
    }
    if (typeof this.staticValidationRules !== 'undefined' && this.staticValidationRules !== null) {
      toReturn['staticValidationRules'] = 'toApiJson' in this.staticValidationRules ? this.staticValidationRules.toApiJson() : this.staticValidationRules;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class RateLimit {
  static fromProto(proto) {
    let m = new RateLimit();
    m = Object.assign(m, proto);
    if (proto.unit) {
      m.unit = enumStringToValue$3(RateLimitUnit, proto.unit);
    }
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.runningVersion !== 'undefined') {
      toReturn['runningVersion'] = this.runningVersion;
    }
    if (typeof this.stepId !== 'undefined') {
      toReturn['stepId'] = this.stepId;
    }
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.unit !== 'undefined') {
      toReturn['unit'] = this.unit;
    }
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SendTestWebhookRequestAdditionalFieldsEntry {
  static fromProto(proto) {
    let m = new SendTestWebhookRequestAdditionalFieldsEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ContinueAutomationFromStepRequest {
  static fromProto(proto) {
    let m = new ContinueAutomationFromStepRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.previousWorkflowStepId !== 'undefined') {
      toReturn['previousWorkflowStepId'] = this.previousWorkflowStepId;
    }
    if (typeof this.previousRunId !== 'undefined') {
      toReturn['previousRunId'] = this.previousRunId;
    }
    if (typeof this.workflowStepIdToContinue !== 'undefined') {
      toReturn['workflowStepIdToContinue'] = this.workflowStepIdToContinue;
    }
    return toReturn;
  }
}
class CopyAutomationRequest {
  static fromProto(proto) {
    let m = new CopyAutomationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.originalAutomationId !== 'undefined') {
      toReturn['originalAutomationId'] = this.originalAutomationId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CopyAutomationResponse {
  static fromProto(proto) {
    let m = new CopyAutomationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CountRunningWorkflowsRequest {
  static fromProto(proto) {
    let m = new CountRunningWorkflowsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    return toReturn;
  }
}
class CountRunningWorkflowsResponse {
  static fromProto(proto) {
    let m = new CountRunningWorkflowsResponse();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class CreateAutomationRequest {
  static fromProto(proto) {
    let m = new CreateAutomationRequest();
    m = Object.assign(m, proto);
    if (proto.automation) {
      m.automation = Automation.fromProto(proto.automation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automation !== 'undefined' && this.automation !== null) {
      toReturn['automation'] = 'toApiJson' in this.automation ? this.automation.toApiJson() : this.automation;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class CreateAutomationResponse {
  static fromProto(proto) {
    let m = new CreateAutomationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateEventTriggerDefinitionRequest {
  static fromProto(proto) {
    let m = new CreateEventTriggerDefinitionRequest();
    m = Object.assign(m, proto);
    if (proto.eventTriggerDefinition) {
      m.eventTriggerDefinition = EventTriggerDefinition.fromProto(proto.eventTriggerDefinition);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTriggerDefinition !== 'undefined' && this.eventTriggerDefinition !== null) {
      toReturn['eventTriggerDefinition'] = 'toApiJson' in this.eventTriggerDefinition ? this.eventTriggerDefinition.toApiJson() : this.eventTriggerDefinition;
    }
    return toReturn;
  }
}
class CreateTaskDefinitionRequest {
  static fromProto(proto) {
    let m = new CreateTaskDefinitionRequest();
    m = Object.assign(m, proto);
    if (proto.taskDefinition) {
      m.taskDefinition = TaskDefinition.fromProto(proto.taskDefinition);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskDefinition !== 'undefined' && this.taskDefinition !== null) {
      toReturn['taskDefinition'] = 'toApiJson' in this.taskDefinition ? this.taskDefinition.toApiJson() : this.taskDefinition;
    }
    return toReturn;
  }
}
class CreateTaskDefinitionResponse {
  static fromProto(proto) {
    let m = new CreateTaskDefinitionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DefaultAutomation {
  static fromProto(proto) {
    let m = new DefaultAutomation();
    m = Object.assign(m, proto);
    if (proto.defaultAutomation) {
      m.defaultAutomation = Automation.fromProto(proto.defaultAutomation);
    }
    if (proto.configuration) {
      m.configuration = AutomationConfigurationV2.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.defaultAutomation !== 'undefined' && this.defaultAutomation !== null) {
      toReturn['defaultAutomation'] = 'toApiJson' in this.defaultAutomation ? this.defaultAutomation.toApiJson() : this.defaultAutomation;
    }
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class DefaultAutomationWithConfiguration {
  static fromProto(proto) {
    let m = new DefaultAutomationWithConfiguration();
    m = Object.assign(m, proto);
    if (proto.defaultAutomation) {
      m.defaultAutomation = Automation.fromProto(proto.defaultAutomation);
    }
    if (proto.configuration) {
      m.configuration = AutomationConfiguration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.defaultAutomation !== 'undefined' && this.defaultAutomation !== null) {
      toReturn['defaultAutomation'] = 'toApiJson' in this.defaultAutomation ? this.defaultAutomation.toApiJson() : this.defaultAutomation;
    }
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class DeleteAutomationRequest {
  static fromProto(proto) {
    let m = new DeleteAutomationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeleteConfigurationRequest {
  static fromProto(proto) {
    let m = new DeleteConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    return toReturn;
  }
}
class DeleteEventTriggerDefinitionRequest {
  static fromProto(proto) {
    let m = new DeleteEventTriggerDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    return toReturn;
  }
}
class DeleteTaskDefinitionRequest {
  static fromProto(proto) {
    let m = new DeleteTaskDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DisableAutomationConfigurationRequest {
  static fromProto(proto) {
    let m = new DisableAutomationConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.automationConfigurationId) {
      m.automationConfigurationId = AutomationConfigurationV2Identifier.fromProto(proto.automationConfigurationId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationConfigurationId !== 'undefined' && this.automationConfigurationId !== null) {
      toReturn['automationConfigurationId'] = 'toApiJson' in this.automationConfigurationId ? this.automationConfigurationId.toApiJson() : this.automationConfigurationId;
    }
    return toReturn;
  }
}
class DisableForMarketsRequest {
  static fromProto(proto) {
    let m = new DisableForMarketsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}
class EmitAutomationEventRequest {
  static fromProto(proto) {
    let m = new EmitAutomationEventRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    if (typeof this.eventData !== 'undefined') {
      toReturn['eventData'] = this.eventData;
    }
    return toReturn;
  }
}
class EnableAutomationConfigurationRequest {
  static fromProto(proto) {
    let m = new EnableAutomationConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.automationConfigurationId) {
      m.automationConfigurationId = AutomationConfigurationV2Identifier.fromProto(proto.automationConfigurationId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationConfigurationId !== 'undefined' && this.automationConfigurationId !== null) {
      toReturn['automationConfigurationId'] = 'toApiJson' in this.automationConfigurationId ? this.automationConfigurationId.toApiJson() : this.automationConfigurationId;
    }
    return toReturn;
  }
}
class EnableForMarketsRequest {
  static fromProto(proto) {
    let m = new EnableForMarketsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}
class EndAutomationRunRequest {
  static fromProto(proto) {
    let m = new EndAutomationRunRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.runId !== 'undefined') {
      toReturn['runId'] = this.runId;
    }
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.workflowStepId !== 'undefined') {
      toReturn['workflowStepId'] = this.workflowStepId;
    }
    if (typeof this.mainRunId !== 'undefined') {
      toReturn['mainRunId'] = this.mainRunId;
    }
    if (typeof this.stepExecutionUuid !== 'undefined') {
      toReturn['stepExecutionUuid'] = this.stepExecutionUuid;
    }
    return toReturn;
  }
}
class ListAutomationsRequestV2Filters {
  static fromProto(proto) {
    let m = new ListAutomationsRequestV2Filters();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue(Context, proto.context);
    }
    if (proto.automationTypes) {
      m.automationTypes = proto.automationTypes.map(v => enumStringToValue(AutomationType, v));
    }
    if (proto.runningStates) {
      m.runningStates = proto.runningStates.map(v => enumStringToValue(RunningState, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.automationTypes !== 'undefined') {
      toReturn['automationTypes'] = this.automationTypes;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.runningStates !== 'undefined') {
      toReturn['runningStates'] = this.runningStates;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.triggerTaskDefinitionIds !== 'undefined') {
      toReturn['triggerTaskDefinitionIds'] = this.triggerTaskDefinitionIds;
    }
    if (typeof this.lastUpdatedBy !== 'undefined') {
      toReturn['lastUpdatedBy'] = this.lastUpdatedBy;
    }
    if (typeof this.tokenUserId !== 'undefined') {
      toReturn['tokenUserId'] = this.tokenUserId;
    }
    if (typeof this.parentNamespace !== 'undefined') {
      toReturn['parentNamespace'] = this.parentNamespace;
    }
    if (typeof this.excludePlatformAutomations !== 'undefined') {
      toReturn['excludePlatformAutomations'] = this.excludePlatformAutomations;
    }
    return toReturn;
  }
}
class ListActivitiesCurrentlyWaitingRequestFilters {
  static fromProto(proto) {
    let m = new ListActivitiesCurrentlyWaitingRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.workflowStepId !== 'undefined') {
      toReturn['workflowStepId'] = this.workflowStepId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ListAutomationRunsRequestFilters {
  static fromProto(proto) {
    let m = new ListAutomationRunsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.stages) {
      m.stages = proto.stages.map(v => enumStringToValue(Stage, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.stages !== 'undefined') {
      toReturn['stages'] = this.stages;
    }
    if (typeof this.showDefault !== 'undefined') {
      toReturn['showDefault'] = this.showDefault;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ListDefaultAutomationsForPartnerRequestFilters {
  static fromProto(proto) {
    let m = new ListDefaultAutomationsForPartnerRequestFilters();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(DefaultAutomationStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class ListSnippetsRequestFilters {
  static fromProto(proto) {
    let m = new ListSnippetsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue(Context, proto.context);
    }
    if (proto.publishedStates) {
      m.publishedStates = proto.publishedStates.map(v => enumStringToValue(AutomationPublishedState, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.parentNamespace !== 'undefined') {
      toReturn['parentNamespace'] = this.parentNamespace;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.publishedStates !== 'undefined') {
      toReturn['publishedStates'] = this.publishedStates;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class ListActivitiesRequestFilters {
  static fromProto(proto) {
    let m = new ListActivitiesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.stage) {
      m.stage = proto.stage.map(v => enumStringToValue(Stage, v));
    }
    if (proto.automationType) {
      m.automationType = enumStringToValue(AutomationType, proto.automationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.runId !== 'undefined') {
      toReturn['runId'] = this.runId;
    }
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.workflowStepId !== 'undefined') {
      toReturn['workflowStepId'] = this.workflowStepId;
    }
    if (typeof this.stage !== 'undefined') {
      toReturn['stage'] = this.stage;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.latestPerAutomation !== 'undefined') {
      toReturn['latestPerAutomation'] = this.latestPerAutomation;
    }
    if (typeof this.automationType !== 'undefined') {
      toReturn['automationType'] = this.automationType;
    }
    if (typeof this.onlyErrors !== 'undefined') {
      toReturn['onlyErrors'] = this.onlyErrors;
    }
    if (typeof this.mainRunId !== 'undefined') {
      toReturn['mainRunId'] = this.mainRunId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ListTaskDefinitionsRequestFilters {
  static fromProto(proto) {
    let m = new ListTaskDefinitionsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.taskType) {
      m.taskType = enumStringToValue(TaskType, proto.taskType);
    }
    if (proto.publishedState) {
      m.publishedState = enumStringToValue(PublishedState, proto.publishedState);
    }
    if (proto.waitForDataTypeScope) {
      m.waitForDataTypeScope = enumStringToValue(DataType, proto.waitForDataTypeScope);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue(Context, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskType !== 'undefined') {
      toReturn['taskType'] = this.taskType;
    }
    if (typeof this.internal !== 'undefined') {
      toReturn['internal'] = this.internal;
    }
    if (typeof this.publishedState !== 'undefined') {
      toReturn['publishedState'] = this.publishedState;
    }
    if (typeof this.onlyAvailableInDefaultAutomations !== 'undefined') {
      toReturn['onlyAvailableInDefaultAutomations'] = this.onlyAvailableInDefaultAutomations;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.waitForDataTypeScope !== 'undefined') {
      toReturn['waitForDataTypeScope'] = this.waitForDataTypeScope;
    }
    if (typeof this.marketReliant !== 'undefined') {
      toReturn['marketReliant'] = this.marketReliant;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    return toReturn;
  }
}
class SearchManualAutomationsRequestFilters {
  static fromProto(proto) {
    let m = new SearchManualAutomationsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.entityTypes) {
      m.entityTypes = proto.entityTypes.map(v => enumStringToValue(EntityType, v));
    }
    if (proto.context) {
      m.context = enumStringToValue(Context, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.onlySalesRunnable !== 'undefined') {
      toReturn['onlySalesRunnable'] = this.onlySalesRunnable;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.entityTypes !== 'undefined') {
      toReturn['entityTypes'] = this.entityTypes;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    return toReturn;
  }
}
class ListEventTriggerDefinitionRequestFilters {
  static fromProto(proto) {
    let m = new ListEventTriggerDefinitionRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class ListAutomationsRequestFilters {
  static fromProto(proto) {
    let m = new ListAutomationsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.runningStates) {
      m.runningStates = proto.runningStates.map(v => enumStringToValue(RunningState, v));
    }
    if (proto.automationType) {
      m.automationType = enumStringToValue(AutomationType, proto.automationType);
    }
    if (proto.publishedStates) {
      m.publishedStates = proto.publishedStates.map(v => enumStringToValue(AutomationPublishedState, v));
    }
    if (proto.status) {
      m.status = proto.status.map(v => enumStringToValue(AutomationStatus, v));
    }
    if (proto.context) {
      m.context = enumStringToValue(Context, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.lastUpdatedBy !== 'undefined') {
      toReturn['lastUpdatedBy'] = this.lastUpdatedBy;
    }
    if (typeof this.includeDeleted !== 'undefined') {
      toReturn['includeDeleted'] = this.includeDeleted;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.runningStates !== 'undefined') {
      toReturn['runningStates'] = this.runningStates;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.automationType !== 'undefined') {
      toReturn['automationType'] = this.automationType;
    }
    if (typeof this.publishedStates !== 'undefined') {
      toReturn['publishedStates'] = this.publishedStates;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.workflowStepTaskDefinitionId !== 'undefined') {
      toReturn['workflowStepTaskDefinitionId'] = this.workflowStepTaskDefinitionId;
    }
    if (typeof this.triggerTaskDefinitionId !== 'undefined') {
      toReturn['triggerTaskDefinitionId'] = this.triggerTaskDefinitionId;
    }
    if (typeof this.tokenUserId !== 'undefined') {
      toReturn['tokenUserId'] = this.tokenUserId;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ListDefaultAutomationsRequestFilters {
  static fromProto(proto) {
    let m = new ListDefaultAutomationsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue(Context, proto.context);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(DefaultAutomationStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetAutomationAccessRequirementsRequest {
  static fromProto(proto) {
    let m = new GetAutomationAccessRequirementsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    return toReturn;
  }
}
class GetAutomationAccessRequirementsResponse {
  static fromProto(proto) {
    let m = new GetAutomationAccessRequirementsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.successIds !== 'undefined') {
      toReturn['successIds'] = this.successIds;
    }
    if (typeof this.failedIds !== 'undefined') {
      toReturn['failedIds'] = this.failedIds;
    }
    return toReturn;
  }
}
class GetAutomationConfigurationV2Request {
  static fromProto(proto) {
    let m = new GetAutomationConfigurationV2Request();
    m = Object.assign(m, proto);
    if (proto.automationConfigurationId) {
      m.automationConfigurationId = AutomationConfigurationV2Identifier.fromProto(proto.automationConfigurationId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationConfigurationId !== 'undefined' && this.automationConfigurationId !== null) {
      toReturn['automationConfigurationId'] = 'toApiJson' in this.automationConfigurationId ? this.automationConfigurationId.toApiJson() : this.automationConfigurationId;
    }
    return toReturn;
  }
}
class GetAutomationConfigurationV2Response {
  static fromProto(proto) {
    let m = new GetAutomationConfigurationV2Response();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = AutomationConfigurationV2.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class GetAutomationRequest {
  static fromProto(proto) {
    let m = new GetAutomationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetAutomationResponse {
  static fromProto(proto) {
    let m = new GetAutomationResponse();
    m = Object.assign(m, proto);
    if (proto.automation) {
      m.automation = Automation.fromProto(proto.automation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automation !== 'undefined' && this.automation !== null) {
      toReturn['automation'] = 'toApiJson' in this.automation ? this.automation.toApiJson() : this.automation;
    }
    return toReturn;
  }
}
class GetAutomationTagsRequest {
  static fromProto(proto) {
    let m = new GetAutomationTagsRequest();
    m = Object.assign(m, proto);
    if (proto.automationType) {
      m.automationType = enumStringToValue(AutomationType, proto.automationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.automationType !== 'undefined') {
      toReturn['automationType'] = this.automationType;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetAutomationTagsResponse {
  static fromProto(proto) {
    let m = new GetAutomationTagsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class GetConfigurationRequest {
  static fromProto(proto) {
    let m = new GetConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    return toReturn;
  }
}
class GetConfigurationResponse {
  static fromProto(proto) {
    let m = new GetConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = AutomationConfiguration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class GetEventTriggerDefinitionRequest {
  static fromProto(proto) {
    let m = new GetEventTriggerDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    return toReturn;
  }
}
class GetEventTriggerDefinitionResponse {
  static fromProto(proto) {
    let m = new GetEventTriggerDefinitionResponse();
    m = Object.assign(m, proto);
    if (proto.eventTriggerDefinition) {
      m.eventTriggerDefinition = EventTriggerDefinition.fromProto(proto.eventTriggerDefinition);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTriggerDefinition !== 'undefined' && this.eventTriggerDefinition !== null) {
      toReturn['eventTriggerDefinition'] = 'toApiJson' in this.eventTriggerDefinition ? this.eventTriggerDefinition.toApiJson() : this.eventTriggerDefinition;
    }
    return toReturn;
  }
}
class GetMultiAutomationsRequest {
  static fromProto(proto) {
    let m = new GetMultiAutomationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.automationIds !== 'undefined') {
      toReturn['automationIds'] = this.automationIds;
    }
    return toReturn;
  }
}
class GetMultiAutomationsResponse {
  static fromProto(proto) {
    let m = new GetMultiAutomationsResponse();
    m = Object.assign(m, proto);
    if (proto.automations) {
      m.automations = proto.automations.map(Automation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automations !== 'undefined' && this.automations !== null) {
      toReturn['automations'] = 'toApiJson' in this.automations ? this.automations.toApiJson() : this.automations;
    }
    return toReturn;
  }
}
class GetMultiTaskDefinitionRequest {
  static fromProto(proto) {
    let m = new GetMultiTaskDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ids !== 'undefined') {
      toReturn['ids'] = this.ids;
    }
    return toReturn;
  }
}
class GetMultiTaskDefinitionResponse {
  static fromProto(proto) {
    let m = new GetMultiTaskDefinitionResponse();
    m = Object.assign(m, proto);
    if (proto.taskDefinitions) {
      m.taskDefinitions = proto.taskDefinitions.map(TaskDefinition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskDefinitions !== 'undefined' && this.taskDefinitions !== null) {
      toReturn['taskDefinitions'] = 'toApiJson' in this.taskDefinitions ? this.taskDefinitions.toApiJson() : this.taskDefinitions;
    }
    return toReturn;
  }
}
class GetSubscriptionRequest {
  static fromProto(proto) {
    let m = new GetSubscriptionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    return toReturn;
  }
}
class GetSubscriptionResponse {
  static fromProto(proto) {
    let m = new GetSubscriptionResponse();
    m = Object.assign(m, proto);
    if (proto.subscription) {
      m.subscription = AutomationSubscription.fromProto(proto.subscription);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscription !== 'undefined' && this.subscription !== null) {
      toReturn['subscription'] = 'toApiJson' in this.subscription ? this.subscription.toApiJson() : this.subscription;
    }
    return toReturn;
  }
}
class GetTaskDefinitionRequest {
  static fromProto(proto) {
    let m = new GetTaskDefinitionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetTaskDefinitionResponse {
  static fromProto(proto) {
    let m = new GetTaskDefinitionResponse();
    m = Object.assign(m, proto);
    if (proto.taskDefinition) {
      m.taskDefinition = TaskDefinition.fromProto(proto.taskDefinition);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskDefinition !== 'undefined' && this.taskDefinition !== null) {
      toReturn['taskDefinition'] = 'toApiJson' in this.taskDefinition ? this.taskDefinition.toApiJson() : this.taskDefinition;
    }
    return toReturn;
  }
}
class GetWorkflowStepPredecessorOutputParamsRequest {
  static fromProto(proto) {
    let m = new GetWorkflowStepPredecessorOutputParamsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.workflowStepParentIds !== 'undefined') {
      toReturn['workflowStepParentIds'] = this.workflowStepParentIds;
    }
    if (typeof this.onlyIncludeNamedSteps !== 'undefined') {
      toReturn['onlyIncludeNamedSteps'] = this.onlyIncludeNamedSteps;
    }
    return toReturn;
  }
}
class GetWorkflowStepPredecessorOutputParamsResponse {
  static fromProto(proto) {
    let m = new GetWorkflowStepPredecessorOutputParamsResponse();
    m = Object.assign(m, proto);
    if (proto.workflowStepOutputParameters) {
      m.workflowStepOutputParameters = proto.workflowStepOutputParameters.map(WorkflowStepOutputParameterContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.workflowStepOutputParameters !== 'undefined' && this.workflowStepOutputParameters !== null) {
      toReturn['workflowStepOutputParameters'] = 'toApiJson' in this.workflowStepOutputParameters ? this.workflowStepOutputParameters.toApiJson() : this.workflowStepOutputParameters;
    }
    return toReturn;
  }
}
class HideRequest {
  static fromProto(proto) {
    let m = new HideRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListActivitiesCurrentlyWaitingRequest {
  static fromProto(proto) {
    let m = new ListActivitiesCurrentlyWaitingRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListActivitiesCurrentlyWaitingRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListActivitiesCurrentlyWaitingResponse {
  static fromProto(proto) {
    let m = new ListActivitiesCurrentlyWaitingResponse();
    m = Object.assign(m, proto);
    if (proto.activities) {
      m.activities = proto.activities.map(Activity.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activities !== 'undefined' && this.activities !== null) {
      toReturn['activities'] = 'toApiJson' in this.activities ? this.activities.toApiJson() : this.activities;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListActivitiesRequest {
  static fromProto(proto) {
    let m = new ListActivitiesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListActivitiesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListActivitiesResponse {
  static fromProto(proto) {
    let m = new ListActivitiesResponse();
    m = Object.assign(m, proto);
    if (proto.activities) {
      m.activities = proto.activities.map(Activity.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activities !== 'undefined' && this.activities !== null) {
      toReturn['activities'] = 'toApiJson' in this.activities ? this.activities.toApiJson() : this.activities;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListAutomationRunsRequest {
  static fromProto(proto) {
    let m = new ListAutomationRunsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListAutomationRunsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAutomationRunsResponse {
  static fromProto(proto) {
    let m = new ListAutomationRunsResponse();
    m = Object.assign(m, proto);
    if (proto.automationRuns) {
      m.automationRuns = proto.automationRuns.map(Activity.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationRuns !== 'undefined' && this.automationRuns !== null) {
      toReturn['automationRuns'] = 'toApiJson' in this.automationRuns ? this.automationRuns.toApiJson() : this.automationRuns;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListAutomationsRequest {
  static fromProto(proto) {
    let m = new ListAutomationsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListAutomationsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAutomationsRequestV2 {
  static fromProto(proto) {
    let m = new ListAutomationsRequestV2();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListAutomationsRequestV2Filters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAutomationsResponse {
  static fromProto(proto) {
    let m = new ListAutomationsResponse();
    m = Object.assign(m, proto);
    if (proto.automations) {
      m.automations = proto.automations.map(Automation.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automations !== 'undefined' && this.automations !== null) {
      toReturn['automations'] = 'toApiJson' in this.automations ? this.automations.toApiJson() : this.automations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListDefaultAutomationsForPartnerRequest {
  static fromProto(proto) {
    let m = new ListDefaultAutomationsForPartnerRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListDefaultAutomationsForPartnerRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListDefaultAutomationsForPartnerResponse {
  static fromProto(proto) {
    let m = new ListDefaultAutomationsForPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(DefaultAutomationWithConfiguration.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListDefaultAutomationsRequest {
  static fromProto(proto) {
    let m = new ListDefaultAutomationsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListDefaultAutomationsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListDefaultAutomationsResponse {
  static fromProto(proto) {
    let m = new ListDefaultAutomationsResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(DefaultAutomation.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListEventTriggerDefinitionRequest {
  static fromProto(proto) {
    let m = new ListEventTriggerDefinitionRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListEventTriggerDefinitionRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListEventTriggerDefinitionResponse {
  static fromProto(proto) {
    let m = new ListEventTriggerDefinitionResponse();
    m = Object.assign(m, proto);
    if (proto.eventTriggerDefinitions) {
      m.eventTriggerDefinitions = proto.eventTriggerDefinitions.map(EventTriggerDefinition.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTriggerDefinitions !== 'undefined' && this.eventTriggerDefinitions !== null) {
      toReturn['eventTriggerDefinitions'] = 'toApiJson' in this.eventTriggerDefinitions ? this.eventTriggerDefinitions.toApiJson() : this.eventTriggerDefinitions;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListSnippetsRequest {
  static fromProto(proto) {
    let m = new ListSnippetsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSnippetsRequestFilters.fromProto(proto.filters);
    }
    if (proto.validationData) {
      m.validationData = ListSnippetsRequestValidationData.fromProto(proto.validationData);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.validationData !== 'undefined' && this.validationData !== null) {
      toReturn['validationData'] = 'toApiJson' in this.validationData ? this.validationData.toApiJson() : this.validationData;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListSnippetsResponse {
  static fromProto(proto) {
    let m = new ListSnippetsResponse();
    m = Object.assign(m, proto);
    if (proto.snippets) {
      m.snippets = proto.snippets.map(Snippet.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snippets !== 'undefined' && this.snippets !== null) {
      toReturn['snippets'] = 'toApiJson' in this.snippets ? this.snippets.toApiJson() : this.snippets;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListTaskDefinition {
  static fromProto(proto) {
    let m = new ListTaskDefinition();
    m = Object.assign(m, proto);
    if (proto.taskDefinition) {
      m.taskDefinition = TaskDefinition.fromProto(proto.taskDefinition);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.valid !== 'undefined') {
      toReturn['valid'] = this.valid;
    }
    if (typeof this.taskDefinition !== 'undefined' && this.taskDefinition !== null) {
      toReturn['taskDefinition'] = 'toApiJson' in this.taskDefinition ? this.taskDefinition.toApiJson() : this.taskDefinition;
    }
    if (typeof this.hasAccessToRun !== 'undefined') {
      toReturn['hasAccessToRun'] = this.hasAccessToRun;
    }
    return toReturn;
  }
}
class ListTaskDefinitionsRequest {
  static fromProto(proto) {
    let m = new ListTaskDefinitionsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListTaskDefinitionsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.validationData) {
      m.validationData = ListTaskDefinitionsRequestValidationData.fromProto(proto.validationData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.validationData !== 'undefined' && this.validationData !== null) {
      toReturn['validationData'] = 'toApiJson' in this.validationData ? this.validationData.toApiJson() : this.validationData;
    }
    return toReturn;
  }
}
class ListTaskDefinitionsResponse {
  static fromProto(proto) {
    let m = new ListTaskDefinitionsResponse();
    m = Object.assign(m, proto);
    if (proto.taskDefinitions) {
      m.taskDefinitions = proto.taskDefinitions.map(ListTaskDefinition.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskDefinitions !== 'undefined' && this.taskDefinitions !== null) {
      toReturn['taskDefinitions'] = 'toApiJson' in this.taskDefinitions ? this.taskDefinitions.toApiJson() : this.taskDefinitions;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class OrderKey {
  static fromProto(proto) {
    let m = new OrderKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class PublishRequest {
  static fromProto(proto) {
    let m = new PublishRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class RateLimitCheckRequest {
  static fromProto(proto) {
    let m = new RateLimitCheckRequest();
    m = Object.assign(m, proto);
    if (proto.rateLimit) {
      m.rateLimit = RateLimit.fromProto(proto.rateLimit);
    }
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rateLimit !== 'undefined' && this.rateLimit !== null) {
      toReturn['rateLimit'] = 'toApiJson' in this.rateLimit ? this.rateLimit.toApiJson() : this.rateLimit;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    return toReturn;
  }
}
class SearchManualAutomationsRequest {
  static fromProto(proto) {
    let m = new SearchManualAutomationsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = SearchManualAutomationsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.entityType) {
      m.entityType = enumStringToValue(EntityType, proto.entityType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.entityType !== 'undefined') {
      toReturn['entityType'] = this.entityType;
    }
    return toReturn;
  }
}
class SearchManualAutomationsResponse {
  static fromProto(proto) {
    let m = new SearchManualAutomationsResponse();
    m = Object.assign(m, proto);
    if (proto.automations) {
      m.automations = proto.automations.map(Automation.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automations !== 'undefined' && this.automations !== null) {
      toReturn['automations'] = 'toApiJson' in this.automations ? this.automations.toApiJson() : this.automations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class SendTestWebhookRequest {
  static fromProto(proto) {
    let m = new SendTestWebhookRequest();
    m = Object.assign(m, proto);
    if (proto.additionalFields) {
      m.additionalFields = Object.keys(proto.additionalFields).reduce((obj, k) => {
        obj[k] = proto.additionalFields[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.verifierToken !== 'undefined') {
      toReturn['verifierToken'] = this.verifierToken;
    }
    if (typeof this.additionalFields !== 'undefined' && this.additionalFields !== null) {
      toReturn['additionalFields'] = 'toApiJson' in this.additionalFields ? this.additionalFields.toApiJson() : this.additionalFields;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class SetAutomationToDrainingRequest {
  static fromProto(proto) {
    let m = new SetAutomationToDrainingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class Snippet {
  static fromProto(proto) {
    let m = new Snippet();
    m = Object.assign(m, proto);
    if (proto.automation) {
      m.automation = Automation.fromProto(proto.automation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automation !== 'undefined' && this.automation !== null) {
      toReturn['automation'] = 'toApiJson' in this.automation ? this.automation.toApiJson() : this.automation;
    }
    if (typeof this.valid !== 'undefined') {
      toReturn['valid'] = this.valid;
    }
    return toReturn;
  }
}
class StartAccountGroupAutomationRequest {
  static fromProto(proto) {
    let m = new StartAccountGroupAutomationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.actionListName !== 'undefined') {
      toReturn['actionListName'] = this.actionListName;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class StartAutomationRequestStartAutomationPayload {
  static fromProto(proto) {
    let m = new StartAutomationRequestStartAutomationPayload();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entityId !== 'undefined') {
      toReturn['entityId'] = this.entityId;
    }
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    return toReturn;
  }
}
class StartAutomationRequest {
  static fromProto(proto) {
    let m = new StartAutomationRequest();
    m = Object.assign(m, proto);
    if (proto.orderKeys) {
      m.orderKeys = proto.orderKeys.map(OrderKey.fromProto);
    }
    if (proto.payloads) {
      m.payloads = proto.payloads.map(StartAutomationRequestStartAutomationPayload.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.orderKeys !== 'undefined' && this.orderKeys !== null) {
      toReturn['orderKeys'] = 'toApiJson' in this.orderKeys ? this.orderKeys.toApiJson() : this.orderKeys;
    }
    if (typeof this.payloads !== 'undefined' && this.payloads !== null) {
      toReturn['payloads'] = 'toApiJson' in this.payloads ? this.payloads.toApiJson() : this.payloads;
    }
    if (typeof this.checkAccessOnly !== 'undefined') {
      toReturn['checkAccessOnly'] = this.checkAccessOnly;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class StartAutomationRunningRequest {
  static fromProto(proto) {
    let m = new StartAutomationRunningRequest();
    m = Object.assign(m, proto);
    if (proto.settings) {
      m.settings = AutomationSettings.fromProto(proto.settings);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.settings !== 'undefined' && this.settings !== null) {
      toReturn['settings'] = 'toApiJson' in this.settings ? this.settings.toApiJson() : this.settings;
    }
    if (typeof this.subscribeToNotifications !== 'undefined') {
      toReturn['subscribeToNotifications'] = this.subscribeToNotifications;
    }
    return toReturn;
  }
}
class StopAllAutomationRunsRequest {
  static fromProto(proto) {
    let m = new StopAllAutomationRunsRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue(Context, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    return toReturn;
  }
}
class StopAutomationRunningRequest {
  static fromProto(proto) {
    let m = new StopAutomationRunningRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class SubscribeRequest {
  static fromProto(proto) {
    let m = new SubscribeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class SummarizeAutomationRequest {
  static fromProto(proto) {
    let m = new SummarizeAutomationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.prompts !== 'undefined') {
      toReturn['prompts'] = this.prompts;
    }
    return toReturn;
  }
}
class SummarizeAutomationResponse {
  static fromProto(proto) {
    let m = new SummarizeAutomationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.summary !== 'undefined') {
      toReturn['summary'] = this.summary;
    }
    return toReturn;
  }
}
class UnhideRequest {
  static fromProto(proto) {
    let m = new UnhideRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class UnpublishRequest {
  static fromProto(proto) {
    let m = new UnpublishRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class UnsubscribeRequest {
  static fromProto(proto) {
    let m = new UnsubscribeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    return toReturn;
  }
}
class UpdateAutomationRequest {
  static fromProto(proto) {
    let m = new UpdateAutomationRequest();
    m = Object.assign(m, proto);
    if (proto.automation) {
      m.automation = Automation.fromProto(proto.automation);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automation !== 'undefined' && this.automation !== null) {
      toReturn['automation'] = 'toApiJson' in this.automation ? this.automation.toApiJson() : this.automation;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateEventTriggerDefinitionRequest {
  static fromProto(proto) {
    let m = new UpdateEventTriggerDefinitionRequest();
    m = Object.assign(m, proto);
    if (proto.eventTriggerDefinition) {
      m.eventTriggerDefinition = EventTriggerDefinition.fromProto(proto.eventTriggerDefinition);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTriggerDefinition !== 'undefined' && this.eventTriggerDefinition !== null) {
      toReturn['eventTriggerDefinition'] = 'toApiJson' in this.eventTriggerDefinition ? this.eventTriggerDefinition.toApiJson() : this.eventTriggerDefinition;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateTaskDefinitionRequest {
  static fromProto(proto) {
    let m = new UpdateTaskDefinitionRequest();
    m = Object.assign(m, proto);
    if (proto.taskDefinition) {
      m.taskDefinition = TaskDefinition.fromProto(proto.taskDefinition);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.taskDefinition !== 'undefined' && this.taskDefinition !== null) {
      toReturn['taskDefinition'] = 'toApiJson' in this.taskDefinition ? this.taskDefinition.toApiJson() : this.taskDefinition;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class ListTaskDefinitionsRequestValidationData {
  static fromProto(proto) {
    let m = new ListTaskDefinitionsRequestValidationData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.workflowStepParentIds !== 'undefined') {
      toReturn['workflowStepParentIds'] = this.workflowStepParentIds;
    }
    if (typeof this.triggerTaskDefinitionId !== 'undefined') {
      toReturn['triggerTaskDefinitionId'] = this.triggerTaskDefinitionId;
    }
    return toReturn;
  }
}
class ListSnippetsRequestValidationData {
  static fromProto(proto) {
    let m = new ListSnippetsRequestValidationData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.immediateStepParentIds !== 'undefined') {
      toReturn['immediateStepParentIds'] = this.immediateStepParentIds;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'automata-api.vendasta-local.com',
  'test': '',
  'demo': 'automata-demo.apigateway.co',
  'prod': 'automata-prod.apigateway.co',
  'production': 'automata-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AutomataApiService = /*#__PURE__*/(() => {
  class AutomataApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createAutomation(r) {
      const request = r.toApiJson ? r : new CreateAutomationRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/CreateAutomation", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAutomationResponse.fromProto(resp)));
    }
    getAutomation(r) {
      const request = r.toApiJson ? r : new GetAutomationRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/GetAutomation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAutomationResponse.fromProto(resp)));
    }
    getMultiAutomations(r) {
      const request = r.toApiJson ? r : new GetMultiAutomationsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/GetMultiAutomations", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAutomationsResponse.fromProto(resp)));
    }
    deleteAutomation(r) {
      const request = r.toApiJson ? r : new DeleteAutomationRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/DeleteAutomation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateAutomation(r) {
      const request = r.toApiJson ? r : new UpdateAutomationRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/UpdateAutomation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    publish(r) {
      const request = r.toApiJson ? r : new PublishRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/Publish", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unpublish(r) {
      const request = r.toApiJson ? r : new UnpublishRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/Unpublish", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    hide(r) {
      const request = r.toApiJson ? r : new HideRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/Hide", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unhide(r) {
      const request = r.toApiJson ? r : new UnhideRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/Unhide", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    startAutomationRunning(r) {
      const request = r.toApiJson ? r : new StartAutomationRunningRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/StartAutomationRunning", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    stopAutomationRunning(r) {
      const request = r.toApiJson ? r : new StopAutomationRunningRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/StopAutomationRunning", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setAutomationToDraining(r) {
      const request = r.toApiJson ? r : new SetAutomationToDrainingRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/SetAutomationToDraining", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listAutomations(r) {
      const request = r.toApiJson ? r : new ListAutomationsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/ListAutomations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAutomationsResponse.fromProto(resp)));
    }
    listAutomationsV2(r) {
      const request = r.toApiJson ? r : new ListAutomationsRequestV2(r);
      return this.http.post(this._host + "/automata.v1.Automata/ListAutomationsV2", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAutomationsResponse.fromProto(resp)));
    }
    listSnippets(r) {
      const request = r.toApiJson ? r : new ListSnippetsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/ListSnippets", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSnippetsResponse.fromProto(resp)));
    }
    listActivities(r) {
      const request = r.toApiJson ? r : new ListActivitiesRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/ListActivities", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActivitiesResponse.fromProto(resp)));
    }
    copyAutomation(r) {
      const request = r.toApiJson ? r : new CopyAutomationRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/CopyAutomation", request.toApiJson(), this.apiOptions()).pipe(map(resp => CopyAutomationResponse.fromProto(resp)));
    }
    getAutomationTags(r) {
      const request = r.toApiJson ? r : new GetAutomationTagsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/GetAutomationTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAutomationTagsResponse.fromProto(resp)));
    }
    subscribe(r) {
      const request = r.toApiJson ? r : new SubscribeRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/Subscribe", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unsubscribe(r) {
      const request = r.toApiJson ? r : new UnsubscribeRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/Unsubscribe", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSubscription(r) {
      const request = r.toApiJson ? r : new GetSubscriptionRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/GetSubscription", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubscriptionResponse.fromProto(resp)));
    }
    listActivitiesCurrentlyWaiting(r) {
      const request = r.toApiJson ? r : new ListActivitiesCurrentlyWaitingRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/ListActivitiesCurrentlyWaiting", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActivitiesCurrentlyWaitingResponse.fromProto(resp)));
    }
    getWorkflowStepPredecessorOutputParams(r) {
      const request = r.toApiJson ? r : new GetWorkflowStepPredecessorOutputParamsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/GetWorkflowStepPredecessorOutputParams", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWorkflowStepPredecessorOutputParamsResponse.fromProto(resp)));
    }
    listAutomationRuns(r) {
      const request = r.toApiJson ? r : new ListAutomationRunsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/ListAutomationRuns", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAutomationRunsResponse.fromProto(resp)));
    }
    countRunningWorkflows(r) {
      const request = r.toApiJson ? r : new CountRunningWorkflowsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/CountRunningWorkflows", request.toApiJson(), this.apiOptions()).pipe(map(resp => CountRunningWorkflowsResponse.fromProto(resp)));
    }
    stopAllAutomationRuns(r) {
      const request = r.toApiJson ? r : new StopAllAutomationRunsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/StopAllAutomationRuns", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAutomationAccessRequirements(r) {
      const request = r.toApiJson ? r : new GetAutomationAccessRequirementsRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/GetAutomationAccessRequirements", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAutomationAccessRequirementsResponse.fromProto(resp)));
    }
    summarizeAutomation(r) {
      const request = r.toApiJson ? r : new SummarizeAutomationRequest(r);
      return this.http.post(this._host + "/automata.v1.Automata/SummarizeAutomation", request.toApiJson(), this.apiOptions()).pipe(map(resp => SummarizeAutomationResponse.fromProto(resp)));
    }
  }
  AutomataApiService.ɵfac = function AutomataApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomataApiService)();
  };
  AutomataApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomataApiService,
    factory: AutomataApiService.ɵfac,
    providedIn: 'root'
  });
  return AutomataApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PagedResponse {
  constructor(results, nextCursor, hasMore, totalResults) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
    this.totalResults = totalResults;
  }
}
function fillEmptyAutomationValues(automation) {
  if (!(automation.settings && automation.settings.runType)) {
    automation.settings = {
      runType: RunType.RUN_TYPE_MULTIPLE
    };
  }
  return new Automation(automation);
}
let AutomataService = /*#__PURE__*/(() => {
  class AutomataService {
    constructor(api, hostService) {
      this.api = api;
      this.hostService = hostService;
    }
    createAutomation(automation, sourceId) {
      return this.api.createAutomation({
        automation: automation,
        sourceId: sourceId
      }).pipe(map(resp => resp.id));
    }
    getAutomation(id) {
      return this.api.getAutomation({
        id: id
      }).pipe(map(resp => fillEmptyAutomationValues(resp.automation)));
    }
    getMultiAutomations(partnerId, marketId, automationIds) {
      return this.api.getMultiAutomations({
        partnerId: partnerId,
        marketId: marketId,
        automationIds: automationIds
      }).pipe(map(resp => resp.automations));
    }
    updateAutomation(automation, fieldMask) {
      return this.api.updateAutomation({
        automation: automation,
        fieldMask: fieldMask
      }).pipe(map(() => true));
    }
    deleteAutomation(id) {
      return this.api.deleteAutomation({
        id: id
      }).pipe(map(() => true));
    }
    listAutomations(filters, cursor, pageSize) {
      const req = new ListAutomationsRequest({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
      return this.api.listAutomations(req).pipe(map(resp => {
        return new PagedResponse(resp.automations, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    listAutomationsV2(filters, cursor, pageSize) {
      const req = new ListAutomationsRequestV2({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
      return this.api.listAutomationsV2(req).pipe(map(resp => {
        return new PagedResponse(resp.automations, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    listSnippets(filters, validationData, pagingOptions) {
      const req = new ListSnippetsRequest({
        filters: filters,
        validationData: validationData,
        pagingOptions: pagingOptions
      });
      return this.api.listSnippets(req).pipe(map(resp => {
        return new PagedResponse(resp.snippets, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    startAutomationRunning(id, settings, subscribeToNotifications) {
      return this.api.startAutomationRunning({
        id: id,
        settings: settings,
        subscribeToNotifications: subscribeToNotifications
      }).pipe(map(() => true));
    }
    stopAutomationRunning(id) {
      return this.api.stopAutomationRunning({
        id: id
      }).pipe(map(() => true));
    }
    setAutomationToDraining(id) {
      return this.api.setAutomationToDraining({
        id: id
      }).pipe(map(() => true));
    }
    stopAllAutomationRuns(partnerId, context) {
      return this.api.stopAllAutomationRuns({
        partnerId: partnerId,
        context: context
      }).pipe(map(() => true));
    }
    listActivities(filters, cursor, pageSize) {
      const req = new ListActivitiesRequest({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
      return this.api.listActivities(req).pipe(map(resp => {
        return new PagedResponse(resp.activities, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    listCurrentlyWaitingActivities(partnerId, marketIds, automationId, workflowStepId, cursor, pageSize) {
      const req = new ListActivitiesCurrentlyWaitingRequest({
        filters: {
          automationId: automationId,
          workflowStepId: workflowStepId,
          partnerId: partnerId,
          marketIds: marketIds
        },
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
      return this.api.listActivitiesCurrentlyWaiting(req).pipe(map(resp => {
        return new PagedResponse(resp.activities, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    getWorkflowStepPredecessorOutputParams(automationId, workflowStepParentIds, onlyIncludeNamedSteps) {
      return this.api.getWorkflowStepPredecessorOutputParams({
        automationId: automationId,
        workflowStepParentIds: workflowStepParentIds,
        onlyIncludeNamedSteps: onlyIncludeNamedSteps
      }).pipe(map(resp => resp.workflowStepOutputParameters || []));
    }
    copyAutomation(originalAutomationId, name) {
      return this.api.copyAutomation({
        originalAutomationId: originalAutomationId,
        name: name
      }).pipe(map(resp => resp.id));
    }
    getOauth2EntryHandlerUrl(automationId, action, originUrl, settings, subscribeToNotifications) {
      const settingsString = JSON.stringify(settings);
      const params = {
        automation: automationId,
        action: action,
        redirect: originUrl,
        settings: settingsString,
        subscribeToNotifications: subscribeToNotifications || false
      };
      const query = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&');
      return this.hostService.hostWithScheme + '/auth/entry?' + query;
    }
    getTags(partnerId, marketIds, type) {
      const automationType = !!type ? type : AutomationType.AUTOMATION_TYPE_STANDARD;
      return this.api.getAutomationTags({
        partnerId: partnerId,
        marketIds: marketIds,
        automationType: automationType
      }).pipe(map(resp => resp.tags || []));
    }
    publish(automationId) {
      return this.api.publish({
        id: automationId
      }).pipe(map(() => true));
    }
    unpublish(automationId) {
      return this.api.unpublish({
        id: automationId
      }).pipe(map(() => true));
    }
    hide(automationId) {
      return this.api.hide({
        id: automationId
      }).pipe(map(() => true));
    }
    unhide(automationId) {
      return this.api.unhide({
        id: automationId
      }).pipe(map(() => true));
    }
    subscribe(partnerId, marketIds, automationId) {
      return this.api.subscribe({
        partnerId: partnerId,
        marketIds: marketIds,
        automationId: automationId
      }).pipe(map(() => true));
    }
    unsubscribe(automationId) {
      return this.api.unsubscribe({
        automationId: automationId
      }).pipe(map(() => true));
    }
    getSubscription(automationId) {
      return this.api.getSubscription({
        automationId: automationId
      }).pipe(map(resp => resp?.subscription));
    }
    listAutomationRuns(filters, cursor, pageSize) {
      const req = new ListAutomationRunsRequest({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
      return this.api.listAutomationRuns(req).pipe(map(resp => {
        return new PagedResponse(resp.automationRuns, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    getAutomationAccessRequirements(automationId) {
      return this.api.getAutomationAccessRequirements({
        automationId: automationId
      }).pipe(map(res => res));
    }
    summarizeAutomation(automationId, prompts) {
      return this.api.summarizeAutomation({
        automationId: automationId,
        prompts: prompts
      });
    }
  }
  AutomataService.ɵfac = function AutomataService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomataService)(i0.ɵɵinject(AutomataApiService), i0.ɵɵinject(HostService));
  };
  AutomataService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomataService,
    factory: AutomataService.ɵfac,
    providedIn: 'root'
  });
  return AutomataService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AutomataDevelopmentApiService = /*#__PURE__*/(() => {
  class AutomataDevelopmentApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createEventTriggerDefinition(r) {
      const request = r.toApiJson ? r : new CreateEventTriggerDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/CreateEventTriggerDefinition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateEventTriggerDefinition(r) {
      const request = r.toApiJson ? r : new UpdateEventTriggerDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/UpdateEventTriggerDefinition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getEventTriggerDefinition(r) {
      const request = r.toApiJson ? r : new GetEventTriggerDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/GetEventTriggerDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEventTriggerDefinitionResponse.fromProto(resp)));
    }
    deleteEventTriggerDefinition(r) {
      const request = r.toApiJson ? r : new DeleteEventTriggerDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/DeleteEventTriggerDefinition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listEventTriggerDefinition(r) {
      const request = r.toApiJson ? r : new ListEventTriggerDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/ListEventTriggerDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEventTriggerDefinitionResponse.fromProto(resp)));
    }
    createTaskDefinition(r) {
      const request = r.toApiJson ? r : new CreateTaskDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/CreateTaskDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTaskDefinitionResponse.fromProto(resp)));
    }
    updateTaskDefinition(r) {
      const request = r.toApiJson ? r : new UpdateTaskDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/UpdateTaskDefinition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getTaskDefinition(r) {
      const request = r.toApiJson ? r : new GetTaskDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/GetTaskDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTaskDefinitionResponse.fromProto(resp)));
    }
    getMultiTaskDefinition(r) {
      const request = r.toApiJson ? r : new GetMultiTaskDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/GetMultiTaskDefinition", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiTaskDefinitionResponse.fromProto(resp)));
    }
    deleteTaskDefinition(r) {
      const request = r.toApiJson ? r : new DeleteTaskDefinitionRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/DeleteTaskDefinition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listTaskDefinitions(r) {
      const request = r.toApiJson ? r : new ListTaskDefinitionsRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDevelopment/ListTaskDefinitions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTaskDefinitionsResponse.fromProto(resp)));
    }
  }
  AutomataDevelopmentApiService.ɵfac = function AutomataDevelopmentApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomataDevelopmentApiService)();
  };
  AutomataDevelopmentApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomataDevelopmentApiService,
    factory: AutomataDevelopmentApiService.ɵfac,
    providedIn: 'root'
  });
  return AutomataDevelopmentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AutomataDevelopmentService = /*#__PURE__*/(() => {
  class AutomataDevelopmentService {
    constructor(api) {
      this.api = api;
    }
    createEventTriggerDefinition(eventTriggerDefinition) {
      return this.api.createEventTriggerDefinition({
        eventTriggerDefinition: eventTriggerDefinition
      }).pipe(map(() => true));
    }
    getEventTriggerDefinition(eventTypeId) {
      return this.api.getEventTriggerDefinition({
        eventTypeId: eventTypeId
      }).pipe(map(resp => resp.eventTriggerDefinition));
    }
    deleteEventTriggerDefinition(eventTypeId) {
      return this.api.deleteEventTriggerDefinition({
        eventTypeId: eventTypeId
      }).pipe(map(() => true));
    }
    updateEventTrigger(eventTriggerDefinition, fieldMask) {
      return this.api.updateEventTriggerDefinition({
        eventTriggerDefinition: eventTriggerDefinition,
        fieldMask: fieldMask
      }).pipe(map(() => true));
    }
    createTaskDefinition(taskDefinition) {
      return this.api.createTaskDefinition({
        taskDefinition: taskDefinition
      }).pipe(map(() => true));
    }
    getTaskDefinition(id) {
      return this.api.getTaskDefinition({
        id: id
      }).pipe(map(resp => resp.taskDefinition));
    }
    getMultiTaskDefinition(ids) {
      return this.api.getMultiTaskDefinition({
        ids: ids
      }).pipe(map(resp => resp.taskDefinitions));
    }
    updateTaskDefinition(taskDefinition, fieldMask) {
      return this.api.updateTaskDefinition({
        taskDefinition: taskDefinition,
        fieldMask: fieldMask
      }).pipe(map(() => true));
    }
    deleteTaskDefinition(id) {
      return this.api.deleteTaskDefinition({
        id: id
      }).pipe(map(() => true));
    }
    listTaskDefinitions(filters, validationData, cursor, pageSize) {
      return this.api.listTaskDefinitions({
        filters: filters,
        validationData: validationData,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }).pipe(map(resp => {
        return new PagedResponse(resp.taskDefinitions, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    listEventTriggerDefinitions(filters, cursor, pageSize) {
      return this.api.listEventTriggerDefinition({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }).pipe(map(resp => {
        return new PagedResponse(resp.eventTriggerDefinitions, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
  }
  AutomataDevelopmentService.ɵfac = function AutomataDevelopmentService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomataDevelopmentService)(i0.ɵɵinject(AutomataDevelopmentApiService));
  };
  AutomataDevelopmentService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomataDevelopmentService,
    factory: AutomataDevelopmentService.ɵfac,
    providedIn: 'root'
  });
  return AutomataDevelopmentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AutomataDefaultAutomationsApiService = /*#__PURE__*/(() => {
  class AutomataDefaultAutomationsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getConfiguration(r) {
      const request = r.toApiJson ? r : new GetConfigurationRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/GetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationResponse.fromProto(resp)));
    }
    deleteConfiguration(r) {
      const request = r.toApiJson ? r : new DeleteConfigurationRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/DeleteConfiguration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    disableForMarkets(r) {
      const request = r.toApiJson ? r : new DisableForMarketsRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/DisableForMarkets", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    enableForMarkets(r) {
      const request = r.toApiJson ? r : new EnableForMarketsRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/EnableForMarkets", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listDefaultAutomationsForPartner(r) {
      const request = r.toApiJson ? r : new ListDefaultAutomationsForPartnerRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/ListDefaultAutomationsForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDefaultAutomationsForPartnerResponse.fromProto(resp)));
    }
    listDefaultAutomations(r) {
      const request = r.toApiJson ? r : new ListDefaultAutomationsRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/ListDefaultAutomations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDefaultAutomationsResponse.fromProto(resp)));
    }
    enableAutomationConfigurationV2(r) {
      const request = r.toApiJson ? r : new EnableAutomationConfigurationRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/EnableAutomationConfigurationV2", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    disableAutomationConfigurationV2(r) {
      const request = r.toApiJson ? r : new DisableAutomationConfigurationRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/DisableAutomationConfigurationV2", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAutomationConfigurationV2(r) {
      const request = r.toApiJson ? r : new GetAutomationConfigurationV2Request(r);
      return this.http.post(this._host + "/automata.v1.AutomataDefaultAutomations/GetAutomationConfigurationV2", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAutomationConfigurationV2Response.fromProto(resp)));
    }
  }
  AutomataDefaultAutomationsApiService.ɵfac = function AutomataDefaultAutomationsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomataDefaultAutomationsApiService)();
  };
  AutomataDefaultAutomationsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomataDefaultAutomationsApiService,
    factory: AutomataDefaultAutomationsApiService.ɵfac,
    providedIn: 'root'
  });
  return AutomataDefaultAutomationsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AutomataOperationsApiService = /*#__PURE__*/(() => {
  class AutomataOperationsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    startAccountGroupAutomation(r) {
      const request = r.toApiJson ? r : new StartAccountGroupAutomationRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataOperations/StartAccountGroupAutomation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    searchManualAutomations(r) {
      const request = r.toApiJson ? r : new SearchManualAutomationsRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataOperations/SearchManualAutomations", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchManualAutomationsResponse.fromProto(resp)));
    }
    rateLimitCheck(r) {
      const request = r.toApiJson ? r : new RateLimitCheckRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataOperations/RateLimitCheck", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    startAutomation(r) {
      const request = r.toApiJson ? r : new StartAutomationRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataOperations/StartAutomation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendTestWebhook(r) {
      const request = r.toApiJson ? r : new SendTestWebhookRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataOperations/SendTestWebhook", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    endAutomationRun(r) {
      const request = r.toApiJson ? r : new EndAutomationRunRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataOperations/EndAutomationRun", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    startMigration() {
      return this.http.post(this._host + "/automata.v1.AutomataOperations/StartMigration", {}, {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    continueAutomationFromStep(r) {
      const request = r.toApiJson ? r : new ContinueAutomationFromStepRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataOperations/ContinueAutomationFromStep", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    emitAutomationEvent(r) {
      const request = r.toApiJson ? r : new EmitAutomationEventRequest(r);
      return this.http.post(this._host + "/automata.v1.AutomataOperations/EmitAutomationEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AutomataOperationsApiService.ɵfac = function AutomataOperationsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomataOperationsApiService)();
  };
  AutomataOperationsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomataOperationsApiService,
    factory: AutomataOperationsApiService.ɵfac,
    providedIn: 'root'
  });
  return AutomataOperationsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AutomataDefaultAutomationsService = /*#__PURE__*/(() => {
  class AutomataDefaultAutomationsService {
    constructor(api) {
      this.api = api;
    }
    /**
     * @deprecated Use getConfigurationV2 instead
     */
    getConfiguration(partnerId, automationId) {
      return this.api.getConfiguration({
        partnerId: partnerId,
        automationId: automationId
      }).pipe(map(resp => new AutomationConfiguration(resp.configuration)));
    }
    /**
     * @deprecated There is no replacement for this method
     */
    deleteConfiguration(partnerId, automationId) {
      return this.api.deleteConfiguration({
        partnerId: partnerId,
        automationId: automationId
      }).pipe(map(() => true));
    }
    /**
     * @deprecated Use disable instead
     */
    disableForMarkets(partnerId, automationId, marketIds) {
      return this.api.disableForMarkets({
        partnerId: partnerId,
        automationId: automationId,
        marketIds: marketIds
      }).pipe(map(() => true));
    }
    /**
     * @deprecated Use enable instead
     */
    enableForMarkets(partnerId, automationId, marketIds) {
      return this.api.enableForMarkets({
        partnerId: partnerId,
        automationId: automationId,
        marketIds: marketIds
      }).pipe(map(() => true));
    }
    /**
     * @deprecated Use listDefaultAutomations instead
     */
    listDefaultAutomationsForPartner(filters, cursor, pageSize) {
      const req = new ListDefaultAutomationsForPartnerRequest({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
      return this.api.listDefaultAutomationsForPartner(req).pipe(map(resp => {
        return new PagedResponse(resp.results, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    listDefaultAutomations(filters, cursor, pageSize) {
      const req = new ListDefaultAutomationsRequest({
        filters: filters,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
      return this.api.listDefaultAutomations(req).pipe(map(resp => {
        return new PagedResponse(resp.results, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore, resp.pagingMetadata.totalResults);
      }));
    }
    enable(automationId, context, namespace) {
      return this.api.enableAutomationConfigurationV2({
        automationConfigurationId: {
          automationId: automationId,
          context: context,
          namespace: namespace
        }
      }).pipe(map(() => true));
    }
    disable(automationId, context, namespace) {
      return this.api.disableAutomationConfigurationV2({
        automationConfigurationId: {
          automationId: automationId,
          context: context,
          namespace: namespace
        }
      }).pipe(map(() => true));
    }
    getConfigurationV2(automationId, context, namespace) {
      return this.api.getAutomationConfigurationV2({
        automationConfigurationId: {
          automationId: automationId,
          context: context,
          namespace: namespace
        }
      }).pipe(map(resp => new AutomationConfigurationV2(resp.configuration)));
    }
  }
  AutomataDefaultAutomationsService.ɵfac = function AutomataDefaultAutomationsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomataDefaultAutomationsService)(i0.ɵɵinject(AutomataDefaultAutomationsApiService));
  };
  AutomataDefaultAutomationsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomataDefaultAutomationsService,
    factory: AutomataDefaultAutomationsService.ɵfac,
    providedIn: 'root'
  });
  return AutomataDefaultAutomationsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AutomataOperationsService = /*#__PURE__*/(() => {
  class AutomataOperationsService {
    constructor(api) {
      this.api = api;
    }
    startAccountGroupAutomation(automationId, accountGroupIds, actionListName, namespace) {
      return this.api.startAccountGroupAutomation({
        automationId: automationId,
        accountGroupIds: accountGroupIds,
        actionListName: actionListName,
        namespace: namespace
      }).pipe(map(() => true));
    }
    //deprecated: use searchManualAutomationsWithContext instead.
    searchManualAutomations(searchTerm, partnerId, marketIds, onlySalesRunnable, entityType, pageSize, cursor) {
      if (typeof entityType === 'number') {
        entityType = [entityType];
      }
      return this.api.searchManualAutomations({
        filters: {
          partnerId: partnerId,
          marketIds: marketIds,
          onlySalesRunnable: onlySalesRunnable,
          entityTypes: entityType
        },
        searchTerm: searchTerm,
        pagingOptions: {
          pageSize: pageSize,
          cursor: cursor
        }
      }).pipe(map(resp => {
        return new PagedResponse(resp?.automations?.map(a => fillEmptyAutomationValues(a)), resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore);
      }));
    }
    searchManualAutomationsWithContext(searchTerm, partnerId, marketIds, onlySalesRunnable, entityType, context, pageSize, cursor) {
      if (typeof entityType === 'number') {
        entityType = [entityType];
      }
      return this.api.searchManualAutomations({
        filters: {
          partnerId: partnerId,
          marketIds: marketIds,
          onlySalesRunnable: onlySalesRunnable,
          entityTypes: entityType,
          context: context
        },
        searchTerm: searchTerm,
        pagingOptions: {
          pageSize: pageSize,
          cursor: cursor
        }
      }).pipe(map(resp => {
        return new PagedResponse(resp?.automations?.map(a => fillEmptyAutomationValues(a)), resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore);
      }));
    }
    sendTestWebhook(partnerId, marketId, automationId, url, verifierToken, additionalFields) {
      return this.api.sendTestWebhook({
        partnerId: partnerId,
        marketId: marketId,
        automationId: automationId,
        url: url,
        verifierToken: verifierToken,
        additionalFields: additionalFields
      }).pipe(map(() => true));
    }
    endAutomationRun(automationId, mainRunId, entityId, workflowStepId, stepExecutionUUID) {
      return this.api.endAutomationRun({
        automationId: automationId,
        mainRunId: mainRunId,
        entityId: entityId,
        workflowStepId: workflowStepId,
        stepExecutionUuid: stepExecutionUUID
      }).pipe(map(() => true));
    }
    continueAutomationFromStep(automationId, entityId, previousRunId, previousWorkflowStepId, workflowStepIdToContinue) {
      return this.api.continueAutomationFromStep({
        automationId: automationId,
        entityId: entityId,
        previousRunId: previousRunId,
        previousWorkflowStepId: previousWorkflowStepId,
        workflowStepIdToContinue: workflowStepIdToContinue
      }).pipe(map(() => true));
    }
    startAutomation(automationId, accountGroupIds, orderKeys, payloads, namespace) {
      if (accountGroupIds && (accountGroupIds || []).length > 0) {
        payloads = accountGroupIds.map(accountGroupId => ({
          entityId: accountGroupId
        }));
      }
      if (orderKeys && (orderKeys || []).length > 0) {
        payloads = orderKeys.map(orderKey => ({
          entityId: orderKey.orderId
        }));
      }
      return this.api.startAutomation({
        automationId: automationId,
        payloads: payloads,
        namespace: namespace
      }).pipe(map(() => true));
    }
  }
  AutomataOperationsService.ɵfac = function AutomataOperationsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomataOperationsService)(i0.ɵɵinject(AutomataOperationsApiService));
  };
  AutomataOperationsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomataOperationsService,
    factory: AutomataOperationsService.ɵfac,
    providedIn: 'root'
  });
  return AutomataOperationsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Comparison = /*#__PURE__*/function (Comparison) {
  Comparison["And"] = "And";
  Comparison["Or"] = "Or";
  Comparison["Not"] = "Not";
  Comparison["StringExists"] = "StringExists";
  Comparison["StringEquals"] = "StringEquals";
  Comparison["StringEqualFold"] = "StringEqualFold";
  Comparison["StringContains"] = "StringContains";
  Comparison["StringContainsFold"] = "StringContainsFold";
  Comparison["BoolEquals"] = "BoolEquals";
  Comparison["BoolListContains"] = "BoolListContains";
  Comparison["StringListContains"] = "StringListContains";
  Comparison["StringListContainsAll"] = "StringListContainsAll";
  Comparison["StringListContainsPrefix"] = "StringListContainsPrefix";
  Comparison["StringListContainsPrefixAll"] = "StringListContainsPrefixAll";
  Comparison["StringListContainsFold"] = "StringListContainsFold";
  Comparison["IsOneOfInStringListFold"] = "IsOneOfInStringListFold";
  Comparison["NumberEquals"] = "NumberEquals";
  Comparison["NumberGreaterThan"] = "NumberGreaterThan";
  Comparison["NumberExists"] = "NumberExists";
  Comparison["RandomNumberLessThan"] = "RandomNumberLessThan";
  Comparison["TimeEquals"] = "TimeEquals";
  Comparison["TimeAfter"] = "TimeAfter";
  Comparison["TimeBefore"] = "TimeBefore";
  Comparison["TimeAfterRelative"] = "TimeAfterRelative";
  Comparison["AlwaysTrue"] = "AlwaysTrue";
  Comparison["OrderActionEquals"] = "OrderActionEquals";
  Comparison["ListSizeGreaterThan"] = "ListSizeGreaterThan";
  Comparison["Jump"] = "Jump";
  return Comparison;
}(Comparison || {});
var ValidationErrorCode = /*#__PURE__*/function (ValidationErrorCode) {
  ValidationErrorCode[ValidationErrorCode["GenericError"] = 0] = "GenericError";
  ValidationErrorCode[ValidationErrorCode["StepMissingDataError"] = 1] = "StepMissingDataError";
  ValidationErrorCode[ValidationErrorCode["ExtractDataError"] = 2] = "ExtractDataError";
  ValidationErrorCode[ValidationErrorCode["BuildGraphError"] = 3] = "BuildGraphError";
  ValidationErrorCode[ValidationErrorCode["InvalidWorkflowError"] = 4] = "InvalidWorkflowError";
  ValidationErrorCode[ValidationErrorCode["NotFoundError"] = 5] = "NotFoundError";
  ValidationErrorCode[ValidationErrorCode["GroupError"] = 6] = "GroupError";
  ValidationErrorCode[ValidationErrorCode["OrphanedStepsError"] = 7] = "OrphanedStepsError";
  return ValidationErrorCode;
}(ValidationErrorCode || {});
var Oauth2Action = /*#__PURE__*/function (Oauth2Action) {
  Oauth2Action["Start"] = "start";
  Oauth2Action["UpdateToken"] = "update-token";
  return Oauth2Action;
}(Oauth2Action || {});
// Did Not Run Reason is the possible values of the activityData.reason for an activity with the stage of Stage_STAGE_WORKFLOW_DID_NOT_RUN
var DidNotRunReason = /*#__PURE__*/function (DidNotRunReason) {
  DidNotRunReason["AutomationRunType"] = "AutomationRunType";
  DidNotRunReason["AutomationOneAtATimeRunType"] = "AutomationRunTypeOneAtATime";
  DidNotRunReason["RateLimited"] = "RateLimited";
  DidNotRunReason["TriggerFiltersFailed"] = "TriggerFiltersFailed";
  return DidNotRunReason;
}(DidNotRunReason || {});
/* eslint-disable */
class Rule {
  static fromRuleInterface(ri) {
    const variablePath = ri.variablePath || ri.variable_path;
    const comparison = ri.comparison;
    let rawValue = ri.value;
    if (typeof ri.value === 'string') {
      try {
        rawValue = JSON.parse(ri.value);
      } catch (e) {
        // value was just a bare string
      }
    }
    let value = rawValue;
    if (comparison === Comparison.Not) {
      value = Rule.fromRuleInterface(rawValue);
    }
    if (comparison === Comparison.And || comparison === Comparison.Or) {
      const ruleList = [];
      for (let i = 0; i < (rawValue || []).length; i++) {
        ruleList[i] = Rule.fromRuleInterface(rawValue[i]);
      }
      value = ruleList;
    }
    const rule = new Rule(variablePath, value, ri.next);
    rule.comparison = ri.comparison;
    return rule;
  }
  constructor(variablePath, value, next) {
    this.variablePath = variablePath;
    this.variable_path = variablePath;
    this.value = value;
    this.next = next;
  }
  toRuleInterface() {
    return {
      variablePath: this.getVariablePath(),
      value: JSON.stringify(this.value),
      next: this.next,
      comparison: this.comparison
    };
  }
  // deepEquals will compare the with the rule passed in to see if they have the same logical structure
  // if ignoreValue is true it won't compare against values that aren't rules (not) or a list of rules (and/or)
  deepEquals(rule, ignoreValue) {
    if (this.getVariablePath() !== rule.getVariablePath()) {
      return false;
    }
    if (this.next !== rule.next) {
      return false;
    }
    if (this.comparison !== rule.comparison) {
      return false;
    }
    if (this.comparison === Comparison.Not) {
      const knownAValue = this.value;
      const knownBValue = rule.value;
      return knownAValue.deepEquals(knownBValue, ignoreValue);
    } else if (this.comparison === Comparison.And || this.comparison === Comparison.Or) {
      const knownAValue = this.value;
      const knownBValue = rule.value;
      if (knownAValue.length !== knownBValue.length) {
        return false;
      }
      for (let i = 0; i < knownAValue.length; i++) {
        const same = knownAValue[i].deepEquals(knownBValue[i], ignoreValue);
        if (!same) {
          return false;
        }
      }
    } else if (!ignoreValue) {
      // Only compare the value if the comparison isn't a logical operator
      if (this.comparison === Comparison.StringListContains || this.comparison === Comparison.StringListContainsAll || this.comparison === Comparison.StringListContainsPrefix || this.comparison === Comparison.StringListContainsPrefixAll || this.comparison === Comparison.StringListContainsFold || this.comparison === Comparison.IsOneOfInStringListFold) {
        const value1 = this.value;
        const value2 = rule.value;
        if (value1.length !== value2.length) {
          return false;
        }
        value1.map((value, index) => {
          if (value !== value2[index]) {
            return false;
          }
        });
        return true;
      }
      if (this.value !== rule.value) {
        return false;
      }
    }
    return true;
  }
  // extractValue returns the value or list of values of the rule tree.
  // If there is an AND/OR in the tree the child values are converted to a list
  // The value of NOT is ignored and it's child value is returned.
  // A typed rules eg StringEquals will return the string used for comparison
  extractValue() {
    if (this.comparison === Comparison.Not) {
      const knownRule = this.value;
      return knownRule.extractValue();
    }
    if (this.comparison === Comparison.And || this.comparison === Comparison.Or) {
      const values = [];
      const knownChildRules = this.value;
      for (let i = 0; i < knownChildRules.length; i++) {
        values[i] = knownChildRules[i].extractValue();
      }
      return values;
    }
    return this.value;
  }
  // setValue expects a list if the comparison is AND/OR, and a single value otherwise
  // If the comparison is AND/OR it will iterate the child rules and recursively set the value. If a list of values
  // passed in does not match the count of the children the values will be set in order until one is exhausted
  // If the comparison is NOT the value of the child will be set instead
  // If the comparison is a typed rule eg StringEquals it will set the value field
  setValue(value) {
    if (this.comparison === Comparison.Not) {
      const knownRule = this.value;
      knownRule.setValue(value);
      return;
    }
    if (this.comparison === Comparison.And || this.comparison === Comparison.Or) {
      const knownValue = value;
      const knownChildRules = this.value;
      const maxLength = Math.min(knownValue.length, knownChildRules.length);
      for (let i = 0; i < maxLength; i++) {
        knownChildRules[i].setValue(knownValue[i]);
      }
      return;
    }
    this.value = value;
  }
  getVariablePath() {
    if (this.comparison === Comparison.Not) {
      const knownRule = this.value;
      return knownRule.getVariablePath();
    }
    // Not really sure what to return for AND/OR and not sure if this is even required so just returning the
    // concatenated variable paths
    if (this.comparison === Comparison.And || this.comparison === Comparison.Or) {
      const values = [];
      const knownChildRules = this.value;
      if ((knownChildRules || []).length === 0) {
        return "";
      }
      for (let i = 0; i < knownChildRules.length; i++) {
        values[i] = knownChildRules[i].getVariablePath();
      }
      return values.reduce((prev, cur) => prev + cur);
    }
    return this.variablePath || this.variable_path;
  }
  /**
   * listValuesByVariablePath returns the value(s) of the entry in the rule's value for a given
   * variablePath. It's returned in a list to support scenarios where there is more than one rule
   * that matches the variablePath. Returns empty list if no entry found for the given variablePath.
   *
   * For example `.path` returns values for {.WorkflowStep.stepId.path} and {.path}
   * This also works for `.path.subpath` on {.WorkflowStep.stepId.path.subpath}
   */
  listValuesByVariablePath(variablePath) {
    // Remove {} so we can support {.path} as an input
    variablePath = variablePath.replace("{", "").replace("}", "");
    if (this.comparison === Comparison.Not) {
      const knownRule = this.value;
      if (knownRule.getVariablePath().includes(variablePath)) {
        return [knownRule.value];
      }
    }
    // For AND/OR, return the concatenated values
    if (this.comparison === Comparison.And || this.comparison === Comparison.Or) {
      const values = [];
      const knownChildRules = this.value;
      for (let i = 0; i < knownChildRules.length; i++) {
        const child = knownChildRules[i];
        values.push(...child.listValuesByVariablePath(variablePath));
      }
      return values;
    }
    if (this.getVariablePath().includes(variablePath)) {
      return [this.value];
    }
    return [];
  }
  // setValueByItsVariablePath sets the value of a particular entry in the rule's value given
  // it's variablePath
  setValueByItsVariablePath(variablePath, newValue) {
    // handle when the value is a single value
    if (this.value.length === undefined) {
      if (this.getVariablePath() === variablePath) {
        this.setValue(newValue);
      }
      return;
    }
    // otherwise it's a list
    this.value.map(v => {
      if (v.variablePath === variablePath) {
        v.setValue(newValue);
      }
      return v;
    });
  }
}
class Not extends Rule {
  constructor(value, next) {
    super('', value, next);
    this.comparison = Comparison.Not;
  }
}
class And extends Rule {
  constructor(value, next) {
    super('', value, next);
    this.comparison = Comparison.And;
  }
}
class Or extends Rule {
  constructor(value, next) {
    super('', value, next);
    this.comparison = Comparison.Or;
  }
}
class StringExists extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringExists;
  }
}
class StringEquals extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringEquals;
  }
}
class StringEqualFold extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringEqualFold;
  }
}
class StringContains extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringContains;
  }
}
class StringContainsFold extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringContainsFold;
  }
}
class BoolEquals extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.BoolEquals;
  }
}
class BoolListContains extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.BoolListContains;
  }
}
class ListSizeGreaterThan extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.ListSizeGreaterThan;
  }
}
class StringListContains extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringListContains;
  }
}
class StringListContainsAll extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringListContainsAll;
  }
}
class StringListContainsPrefix extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringListContainsPrefix;
  }
}
class StringListContainsPrefixAll extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringListContainsPrefixAll;
  }
}
class StringListContainsFold extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.StringListContainsFold;
  }
}
class IsOneOfInStringListFold extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.IsOneOfInStringListFold;
  }
}
class NumberGreaterThan extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.NumberGreaterThan;
  }
}
class NumberEquals extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.NumberEquals;
  }
}
class NumberExists extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.NumberExists;
  }
}
class RandomNumberLessThan extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.RandomNumberLessThan;
  }
}
class TimeAfter extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.TimeAfter;
  }
}
class TimeBefore extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.TimeBefore;
  }
}
class TimeEquals extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.TimeEquals;
  }
}
class TimeAfterRelative extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.TimeAfterRelative;
  }
}
class AlwaysTrue extends Rule {
  constructor(next) {
    super('', null, next);
    this.comparison = Comparison.AlwaysTrue;
  }
}
class OrderActionEquals extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.OrderActionEquals;
  }
}
class Jump extends Rule {
  constructor() {
    super(...arguments);
    this.comparison = Comparison.Jump;
  }
}

// NOTE: This logic should be consistent with the utils functions in the automata repo
function IsAutomationAcceptingNewEvents(a) {
  return a?.runningState === RunningState.RUNNING_STATE_RUNNING;
}
function IsAutomationDraining(a) {
  return a?.runningState === RunningState.RUNNING_STATE_DRAINING;
}
function IsAutomationStopped(a) {
  return !a || a.runningState === RunningState.RUNNING_STATE_STOPPED;
}
function IsAutomationAPublishedTemplate(a) {
  return !!a?.isTemplate && !!a?.templatePublishedTime;
}
function IsAutomationAPublishedDefaultAutomation(a) {
  return !!a?.isDefaultAutomation && !IsAutomationStopped(a);
}
function DoesAutomationHaveABrokenToken(a) {
  return !!a?.token?.brokenTime;
}

/**
 * Generated bundle index. Do not edit.
 */

export { Activity, AlwaysTrue, And, AutomataDefaultAutomationsService, AutomataDevelopmentService, AutomataOperationsService, AutomataService, Automation, AutomationConfiguration, AutomationConfigurationV2, AutomationPublishedState, AutomationSettings, AutomationStatus, AutomationType, BoolEquals, BoolListContains, Choices, Comparison, Context, DataType, DefaultAutomation, DefaultAutomationStatus, DefaultAutomationWithConfiguration, DidNotRunReason, DoesAutomationHaveABrokenToken, EntityType, ErrorHandlingType, EventTriggerDefinition, FieldMask, FlattenedConfigDataType, Group, IsAutomationAPublishedDefaultAutomation, IsAutomationAPublishedTemplate, IsAutomationAcceptingNewEvents, IsAutomationDraining, IsAutomationStopped, IsOneOfInStringListFold, Jump, ListSizeGreaterThan, ListTaskDefinition, Not, NumberEquals, NumberExists, NumberGreaterThan, Oauth2Action, Or, OrderActionEquals, OutputParameter, PagedResponse, PublishedState, RandomNumberLessThan, RateLimitUnit, Rule, RunType, RunningState, SleepWaitConditions, Stage, StringContains, StringContainsFold, StringEqualFold, StringEquals, StringExists, StringListContains, StringListContainsAll, StringListContainsFold, StringListContainsPrefix, StringListContainsPrefixAll, TaskDefinition, TaskType, TimeAfter, TimeAfterRelative, TimeBefore, TimeEquals, Token, ValidationErrorCode, ValidationType, WorkflowStep, WorkflowStepOutputParameterContainer };
